import React, { useState, useEffect, useCallback, useRef } from 'react';
import ContractorBlackList from '../../components/ContractorBlackList';
import { useFormButtons } from '../../utils/vbPerms';

const fieldHasNominee = cfg => !!(cfg && cfg.fields && cfg.fields.some(f => f.field === 'nominee_id'));
const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const numFmt = n => n?Number(n).toLocaleString('fa-IR'):'•';

async function API(path, opts={}) {
  const doFetch = () => fetch(`/api/accounting${path}`, {
    headers:{'Content-Type':'application/json',
              Authorization:`Bearer ${localStorage.getItem('access')}`},...opts,
  });
  let res = await doFetch();
  if (res.status===401) {
    const refresh = localStorage.getItem('refresh');
    if (refresh) {
      const rr = await fetch('/api/auth/token/refresh/',{
        method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({refresh}),
      });
      if (rr.ok) {
        const data = await rr.json();
        localStorage.setItem('access', data.access);
        if (data.refresh) localStorage.setItem('refresh', data.refresh);
        res = await doFetch();
      }
    }
  }
  /* اگر سرور JSON برنگرداند (مثلاً ۴۰۴ یا ۵۰۰)، به‌جای خطای بی‌صدای جاوااسکریپت
     پیام روشن برمی‌گردد. */
  try {
    return await res.json();
  } catch (e) {
    return { ok: false, msg: res.status === 404
      ? 'این امکان در دسترس نیست'
      : `خطای سرور (${res.status})` };
  }
}


const COLS = [
  {k:'paper_no',           l:'ردیف',                  w:45,  center:true},
  {k:'sub_coding_code',    l:'حساب معین',              w:80,  center:true},
  {k:'sub_coding_name',    l:'عنوان حساب',             w:180, right:true},
  {k:'debit',              l:'بدهکار',                 w:115, num:true, red:true},
  {k:'credit',             l:'بستانکار',               w:115, num:true, grn:true},
  {k:'year',               l:'سال',                   w:55,  center:true},
  {k:'program_title',      l:'برنامه/طرح',             w:150, right:true},
  {k:'fasl_title',         l:'فصل',                   w:130, right:true},
  {k:'expense_article',    l:'فصل هزینه',              w:130, right:true},
  {k:'expense_detail',     l:'ریزفصل هزینه',           w:130, right:true},
  {k:'expense_part',       l:'قسمت هزینه',             w:130, right:true},
  {k:'expense_kind',       l:'قلم هزینه',              w:130, right:true},
  {k:'inout_number',       l:'چک/فیش',                w:90,  center:true},
  {k:'inout_date',         l:'تاریخ',                  w:80,  center:true},
  {k:'contractor_name',    l:'پیمانکار',               w:140, right:true},
  {k:'person_name',        l:'اشخاص',                  w:120, right:true},
  {k:'receiver_name',      l:'گیرنده وجه',             w:120, right:true},
  {k:'contract_display',   l:'قرارداد',                w:180, right:true},
  {k:'contractor_statement',l:'صورت وضعیت',            w:160, right:true},
  {k:'remark',             l:'شرح ریز',                w:180, right:true},
  {k:'plan_title',         l:'تفصیلی',                 w:140, right:true},
  {k:'plan_detail_title',  l:'ریزتفصیلی',              w:130, right:true},
  {k:'treasury_doc',       l:'نوع اسناد خزانه',         w:130, right:true},
  {k:'vouch_type_name',    l:'نوع سند',                w:100, right:true},
  {k:'amount_receiver_remark',l:'توضیحات',             w:130, right:true},
  {k:'receiver_account',   l:'حساب گیرنده',            w:160, right:true},
  {k:'account_error',      l:'خطای حساب شبا',          w:130, right:true},
  {k:'bank_name',          l:'بانک',                   w:100, right:true},
  {k:'account_info',       l:'مشخصات حساب',            w:160, right:true},
  {k:'credit_title',       l:'منبع اعتبار',            w:150, right:true},
  {k:'source_type_name',   l:'نوع منبع یا درآمد',      w:120, right:true},
  {k:'source_essence_name',l:'ماهیت منبع',             w:110, right:true},
  {k:'other_source_name',  l:'نوع سایر منابع',         w:120, right:true},
  {k:'credit_type_name',   l:'نوع اعتبار',             w:100, right:true},
  {k:'transferal_type_name',l:'سال جاری/متمم/سنواتی',  w:130, right:true},
  {k:'transfer_items_name',l:'اقلام انتقال یافته',      w:110, right:true},
  {k:'credit_info_name',   l:'مشخصات اعتبار',          w:110, right:true},
  {k:'rank_title',         l:'شماره ردیف',             w:130, right:true},
  {k:'sub_budget_title',   l:'ردیف بودجه',             w:130, right:true},
  {k:'project_title',      l:'پروژه',                  w:140, right:true},
  {k:'construct_article',  l:'فصل تملک',               w:130, right:true},
  {k:'income_display',     l:'مشخصات درآمد',           w:140, right:true},
  {k:'income_type_name',   l:'نوع درآمد',              w:110, right:true},
  {k:'other_income_name',  l:'موضوع درآمد',            w:110, right:true},
  {k:'governmental_name',  l:'دولتی/غیردولتی',         w:110, right:true},
  {k:'allocation_name',    l:'منبع تخصیص',             w:110, right:true},
  {k:'tax_season_name',    l:'دوره مالیاتی',           w:100, right:true},
  {k:'sender_title',       l:'ابلاغ دهنده',            w:130, right:true},
  {k:'receiver_title',     l:'ابلاغ گیرنده',           w:130, right:true},
  {k:'cost_center_title',  l:'مرکز هزینه',             w:120, right:true},
  {k:'award_article_name', l:'هدایا و کمک‌ها',          w:120, right:true},
  {k:'securities_name',    l:'نوع اوراق بهادار',        w:120, right:true},
  {k:'guarantee_name',     l:'ماهیت سپرده',            w:110, right:true},
  {k:'demand_status_name', l:'وضعیت مطالبات',          w:120, right:true},
  {k:'temp_payment_name',  l:'انواع پرداخت غیرقطعی',   w:130, right:true},
  {k:'leakage_name',       l:'موضوع کسری ابوابجمعی',   w:130, right:true},
  {k:'receivables_name',   l:'موضوع مطالبات',          w:120, right:true},
  {k:'assurance_type_name',l:'نوع تضمین',              w:110, right:true},
  {k:'assurance_subj_name',l:'موضوع تضمین',            w:110, right:true},
  {k:'currency_name',      l:'واحد پولی',              w:100, right:true},
  {k:'insurance_name',     l:'نوع بیمه',               w:100, right:true},
  {k:'debit_subject_name', l:'موضوع بدهی',             w:110, right:true},
  {k:'fixed_asset_name',   l:'دارایی‌های ثابت',         w:120, right:true},
  {k:'inventory_name',     l:'موجودی‌ها',               w:110, right:true},
  {k:'quantity',           l:'تعداد اوراق',            w:80,  center:true},
  {k:'due_date',           l:'سررسید اوراق',           w:90,  center:true},
  {k:'investment_name',    l:'نوع سرمایه‌گذاری',        w:120, right:true},
  {k:'annual_adj_name',    l:'موضوع تعدیلات',          w:120, right:true},
  {k:'deposit_info',       l:'مشخصات سپرده ثبت شده',   w:160, right:true},
  {k:'has_budget_link',    l:'لینک به اعتبارات',        w:90,  center:true},
  {k:'slip_id',            l:'شناسه پرداخت',           w:120, right:true},
  {k:'bill_id',            l:'شناسه قبض',              w:120, right:true},
  {k:'shomool_name',       l:'شمول',                   w:90,  right:true},
];

/* کامپوننت‌های خارج از main */
const FRow = ({children}) => (
  <div style={{display:'flex',gap:'10px',marginBottom:'10px',flexWrap:'wrap'}}>{children}</div>
);
const FL = ({label,children,third,half}) => (
  <div style={{display:'flex',flexDirection:'column',gap:'3px',
    flex:third?'0 0 31%':half?'0 0 48%':1,minWidth:'120px'}}>
    <label style={{fontSize:'11px',fontWeight:'600',color:'#555'}}>{label}</label>
    {children}
  </div>
);
/* مبلغ با جداکنندهٔ سه‌رقمی — مقدار خام (فقط رقم) در state می‌ماند و فقط نمایش گروه‌بندی می‌شود */
const groupDigits = v => {
  const n = String(v ?? '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/[^0-9]/g, '').replace(/^0+(?=\d)/, '');
  return n ? n.replace(/\B(?=(\d{3})+(?!\d))/g, '٬').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]) : '';
};
const AmountInput = ({name,value,onChange,onFocus,onBlur,onKeyDown,inputRef,readOnly}) => (
  <input name={name} ref={inputRef} value={groupDigits(value)} readOnly={readOnly}
    inputMode="numeric" autoComplete="off"
    onChange={e => onChange({ target: { name, type: 'text',
      value: e.target.value.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/[^0-9]/g, '') } })}
    onFocus={onFocus} onBlur={onBlur} onKeyDown={onKeyDown}
    style={{padding:'6px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',
      fontSize:'13px',fontWeight:'700',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',
      direction:'ltr',textAlign:'left',background:readOnly?'#f5f5f5':'#fff',
      color:readOnly?'#888':'#111',width:'100%',boxSizing:'border-box'}}/>
);
const SHOMOOL = ['شمول', 'داخل شمول', 'خارج شمول'];

const FI = ({name,value,onChange,readOnly,placeholder,onKeyDown,onBlur}) => (
  <input name={name} value={value} onChange={onChange} readOnly={readOnly}
    placeholder={placeholder||''} onKeyDown={onKeyDown} onBlur={onBlur}
    style={{padding:'6px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',
      fontSize:'12px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',
      direction:'rtl',background:readOnly?'#f5f5f5':'#fff',
      color:readOnly?'#888':'#111',width:'100%',boxSizing:'border-box'}}/>
);

const EMPTY = {sub_coding_code:'',remark:'',debit:'',credit:'',year:'',fasl:'',
  program_id:0,project_id:0,plan_id:0,plan_detail_id:0,
  expense_article_id:0,expense_detail_article_id:0,expense_part_id:0,expense_kind_id:0,
  construct_article_id:0,nominee_id:0,people_id:0,amount_receiver_id:0,contract_id:0,
  debenture_sender_id:0,debenture_receiver_id:0,cost_center_id:0,
  vouch_type_group_id:0,account_code:0,credit_id:0,income_id:0,
  source_type:0,source_essence:0,other_source_type:0,credit_type:0,
  transferal_type:0,transfer_items:0,credit_info:0,rank_id:0,sub_budget_id:0,
  income_type:0,other_income_type:0,governmental:0,allocation_source:0,tax_season:0,
  award_article:0,securities_type:0,guarantee_essence:0,demand_status:0,
  temp_payment_type:0,leakage_subject:0,receivables_subject:0,
  assurance_type:0,assurance_subject:0,currency_type:0,insurance_type:0,
  debit_subject:0,fixed_asset_type:0,inventory_type:0,quantity:0,due_date:'',
  investment_type:0,annual_adjustments:0,decrese_credit:false,shomool:0,
  treasury_document_id:0,account_coding_code:0,
};

/* مپینگ فیلد backend به ردیف */
const FIELD_TO_ROW = {
  SourceType:'source_type_name', SourceEssence:'source_essence_name',
  OtherSourceType:'other_source_name', CreditType:'credit_type_name',
  TransferalType:'transferal_type_name', TransferItems:'transfer_items_name',
  CreditInfo:'credit_info_name', RankNumber:'rank_title',
  SubBudgetCode:'sub_budget_title', CreditCode:'program_title',
  ExpenseArticle:'expense_article', ExpenseDetailArticle:'expense_detail',
  ExpensePart:'expense_part', ExpenseKind:'expense_kind',
  ExecutiveUnit:'executive_unit_name',
  ConstructArticle:'construct_article', ConstructDetailArticle:'construct_detail',
  IncomeCode:'income_display', IncomeType:'income_type_name',
  OtherIncomeType:'other_income_name', TaxSeason:'tax_season_name',
  Governmental:'governmental_name', AllocationSource:'allocation_name',
  InvestmentType:'investment_name', AnnualAdjustmentsSubject:'annual_adj_name',
  DebentureSenderRank:'sender_title', DebentureReceiverRank:'receiver_title',
  CostCenter:'cost_center_title', AwardArticle:'award_article_name',
  SecuritiesType:'securities_name', ContractProperties:'contract_display',
  Nominee:'contractor_name', GuaranteeEssence:'guarantee_name',
  DemandStatus:'demand_status_name', TempPaymentType:'temp_payment_name',
  LeakageSubject:'leakage_name', ReceivablesSubject:'receivables_name',
  AssuranceType:'assurance_type_name', AssuranceSubject:'assurance_subj_name',
  CurrencyType:'currency_name', AccountNumber:'account_info',
  InsuranceType:'insurance_name', DebitSubject:'debit_subject_name',
  FixedAssetType:'fixed_asset_name', PropertyType:'property_name',
  FinanceDetailArticle:'finance_detail_name',
  InventoryType:'inventory_name', InventoryDetailArticle:'inventory_detail_name',
  Year:'year', SecuritiesProperties:'deposit_info', Quantity:'quantity',
  /* فیلدهایی که همیشه روی فرم هستند: تفصیلی، ریزتفصیلی، پروژه، منبع اعتبار و
     نوع اسناد خزانه. بدون این‌ها پاپ‌آپ «تفصیلی‌های این قلم» برای معین‌هایی غیر از
     ۱۱۰ خالی می‌ماند. */
  PlanId:'plan_title', PlanDetailId:'plan_detail_title',
  ProjectId:'project_title', CreditId:'credit_title',
  TreasuryDocumentId:'treasury_doc',
};

const toEng = s => String(s).replace(/[۰-۹]/g,d=>'۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
/* تاریخ امروز شمسی به شکل ۱۴۰۵/۰۷/۱۷ با رقم لاتین */
const todayFa = () => {
  const p = new Intl.DateTimeFormat('fa-IR-u-ca-persian-nu-latn',{year:'numeric',month:'2-digit',day:'2-digit'})
    .formatToParts(new Date());
  const g = k => (p.find(x=>x.type===k)||{}).value||'';
  return `${g('year')}/${g('month')}/${g('day')}`;
};
const si = v => { try{return parseInt(toEng(String(v||0)),10)||0;}catch{return 0;} };

/* فیلد لوکاپ → عنوان ردیف لیست (برای نمایش مقدار موجود هنگام ویرایش) */
const LOOKUP_DISPLAY_FROM_ROW = {
  program_id:'program_title', rank_id:'rank_title', sub_budget_id:'sub_budget_title',
  expense_article_id:'expense_article', expense_detail_article_id:'expense_detail',
  expense_part_id:'expense_part', expense_kind_id:'expense_kind',
  executive_unit_id:'executive_unit_name', construct_article_id:'construct_article',
  income_id:'income_display', debenture_sender_id:'sender_title',
  debenture_receiver_id:'receiver_title', cost_center_id:'cost_center_title',
  contract_id:'contract_display', nominee_id:'contractor_name',
  account_code:'account_info', plan_id:'plan_title', plan_detail_id:'plan_detail_title',
  treasury_document_id:'treasury_doc',
};

/* اتوکامپلیت لوکاپ تفصیلی — بیرون از main تا فوکوس با هر کلید نپرد
   props: field, year, value(id), display, onPick(id,label,row), apiFn, title
   دو راه انتخاب دارد: تایپ برای جستجوی سریع، یا دابل‌کلیک برای باز شدن
   پنجرهٔ انتخاب که کل فهرست را با جستجو نشان می‌دهد. */
const DetailLookup = ({ field, year, value, display, onPick, apiFn, title, parent, onKeyDown, readOnly, noAuto }) => {
  /* parent: شناسهٔ سطح بالاتر هزینه (Hazineh1/2/3) */
  const par = parent ? `&parent=${parent}` : '';
  const [q, setQ] = React.useState('');
  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [label, setLabel] = React.useState(display || '');
  const tmr = React.useRef(null);
  const seq = React.useRef(0);   // فقط پاسخ آخرین جستجو اعمال می‌شود (پاسخ دیررسِ جستجوی قبلی نادیده)
  // ── وضعیت پنجرهٔ انتخاب (دابل‌کلیک) ──
  const [picker,   setPicker]   = React.useState(false);
  const [pRows,    setPRows]    = React.useState([]);
  const [pQ,       setPQ]       = React.useState('');
  const [pLoading, setPLoading] = React.useState(false);
  const ptmr = React.useRef(null);
  React.useEffect(()=>{ setLabel(display||''); }, [display, value]);
  const run = (val) => {
    setQ(val); setLabel(val);
    if (tmr.current) clearTimeout(tmr.current);
    const my = ++seq.current;
    if (!val || !val.trim()) { setRows([]); setOpen(false); onPick(0,''); return; }
    tmr.current = setTimeout(async ()=>{
      const j = await apiFn(`/detail-lookup/?field=${field}&q=${encodeURIComponent(toEng(val))}&year=${year}${par}`);
      if (my !== seq.current) return;          // در این فاصله کاربر چیز دیگری تایپ یا انتخاب کرده
      if (!j.ok || !j.data || !j.data.length) { setRows([]); setOpen(true); return; }
      /* یک نتیجه، یا یک نتیجه با کدِ دقیقاً برابر متن تایپ‌شده = انتخاب خودکار */
      const typed = toEng(val).trim();
      const exact = j.data.filter(x => toEng(String(x.code ?? '')).trim() === typed);
      const auto = exact.length === 1 ? exact[0] : (j.data.length === 1 ? j.data[0] : null);
      // noAuto: انتخاب فقط با کلیک کاربر از فهرست (حتی اگر یک نتیجه باشد)
      if (auto && !noAuto) { setRows([]); setOpen(false); pickRef.current(auto, true); return; }
      setRows(j.data); setOpen(true);
    }, 300);
  };
  // auto=true: تنها نتیجهٔ جستجو خودکار انتخاب شد؛ در غیر این صورت کاربر از فهرست برگزید
  const pick = (r, auto = false) => {
    seq.current += 1;
    const lbl = `${r.code} - ${r.title}`.trim();
    setLabel(lbl); setOpen(false); setRows([]);
    onPick(r.id, lbl, r, auto);
  };
  const pickRef = React.useRef(pick);
  pickRef.current = pick;
  // ── بارگذاری فهرست برای پنجرهٔ انتخاب (جستجوی خالی = کل فهرست) ──
  const loadPicker = (val) => {
    setPQ(val);
    if (ptmr.current) clearTimeout(ptmr.current);
    ptmr.current = setTimeout(async ()=>{
      setPLoading(true);
      const j = await apiFn(`/detail-lookup/?field=${field}&q=${encodeURIComponent(toEng(val||''))}&year=${year}&browse=1${par}`);
      setPRows(j && j.ok ? j.data : []);
      setPLoading(false);
    }, 220);
  };
  const openPicker = () => {
    setOpen(false); setPicker(true); setPQ(''); setPRows([]); loadPicker('');
  };
  const pickFromModal = (r) => { pick(r); setPicker(false); };
  return (
    <div style={{position:'relative'}}>
      <input value={toFa(label)} onChange={e=>{ if (!readOnly) run(e.target.value); }}
        readOnly={readOnly}
        onKeyDown={e=>{
          if (readOnly) return;
          if (e.key==='Delete') { seq.current += 1; setLabel(''); setQ(''); onPick(0,''); return; }
          if (onKeyDown) onKeyDown(e, setLabel);
        }}
        onDoubleClick={()=>{ if (!readOnly) openPicker(); }}
        onFocus={()=>{ if(rows.length) setOpen(true); }}
        placeholder="جستجو یا دابل‌کلیک..."
        title="برای باز شدن پنجرهٔ انتخاب دابل‌کلیک کنید"
        style={{padding:'5px 8px',border:'1px solid #e0e0e0',borderRadius:'6px',
          fontSize:'11px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",
          outline:'none',width:'100%',boxSizing:'border-box',direction:'rtl',
          background: readOnly ? '#f3f3f3' : value ? '#f1f8f4' : '#fff'}}/>
      {open && (
        <div style={{position:'absolute',top:'100%',right:0,left:0,zIndex:50,
          background:'#fff',border:'1px solid #ccc',borderRadius:'6px',
          maxHeight:'180px',overflowY:'auto',boxShadow:'0 4px 12px rgba(0,0,0,.15)'}}>
          {rows.length===0 && (
            <div style={{padding:'8px',fontSize:'11px',color:'#999',textAlign:'center'}}>موردی یافت نشد</div>
          )}
          {rows.map(r=>(
            <div key={r.id} onClick={()=>pick(r)}
              style={{padding:'6px 8px',fontSize:'11px',cursor:'pointer',
                borderBottom:'1px solid #f0f0f0',direction:'rtl'}}
              onMouseEnter={e=>e.currentTarget.style.background='#f5f5f5'}
              onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
              <b style={{color:'#1565c0'}}>{toFa(r.code)}</b> — {r.title}
            </div>
          ))}
        </div>
      )}

      {/* ── پنجرهٔ انتخاب (دابل‌کلیک) — فهرست کامل با جستجو ── */}
      {picker && (
        <div onClick={()=>setPicker(false)}
          style={{position:'fixed',inset:0,background:'rgba(10,22,40,.55)',
            display:'flex',alignItems:'center',justifyContent:'center',
            zIndex:100000,padding:'20px'}}>
          <div onClick={e=>e.stopPropagation()}
            style={{background:'#fff',borderRadius:'12px',width:'100%',maxWidth:'520px',
              maxHeight:'82vh',display:'flex',flexDirection:'column',direction:'rtl',
              boxShadow:'0 24px 70px rgba(0,0,0,.45)',overflow:'hidden'}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',
              padding:'12px 16px',background:'linear-gradient(135deg,#1565c0,#1976d2)'}}>
              <span style={{fontSize:'14px',fontWeight:'700',color:'#fff'}}>
                انتخاب {title || ''}
              </span>
              <button onClick={()=>setPicker(false)}
                style={{background:'transparent',border:'none',color:'#fff',fontSize:'18px',
                  cursor:'pointer',lineHeight:1}}>✕</button>
            </div>
            <div style={{padding:'10px 14px',borderBottom:'1px solid #eee'}}>
              <input autoFocus value={toFa(pQ)} onChange={e=>loadPicker(e.target.value)}
                placeholder="جستجو..."
                style={{padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',
                  fontSize:'12px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",
                  outline:'none',width:'100%',boxSizing:'border-box',direction:'rtl'}}/>
            </div>
            <div style={{flex:1,overflowY:'auto',minHeight:'120px'}}>
              {pLoading ? (
                <div style={{padding:'24px',textAlign:'center',color:'#999',fontSize:'12px'}}>⏳ بارگذاری...</div>
              ) : pRows.length === 0 ? (
                <div style={{padding:'24px',textAlign:'center',color:'#bbb',fontSize:'12px'}}>موردی یافت نشد</div>
              ) : pRows.map(r=>(
                <div key={r.id}
                  onClick={()=>pickFromModal(r)}
                  onDoubleClick={()=>pickFromModal(r)}
                  style={{padding:'9px 14px',fontSize:'12px',cursor:'pointer',
                    borderBottom:'1px solid #f2f2f2',display:'flex',gap:'8px',alignItems:'center'}}
                  onMouseEnter={e=>e.currentTarget.style.background='#eef5ff'}
                  onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                  <b style={{color:'#1565c0',minWidth:'70px'}}>{toFa(r.code)}</b>
                  <span>{r.title}</span>
                </div>
              ))}
            </div>
            <div style={{padding:'8px 14px',borderTop:'1px solid #eee',
              fontSize:'11px',color:'#999',textAlign:'center'}}>
              روی ردیف کلیک کنید تا انتخاب شود
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default function DocumentDetailModal({ doc, year, onClose }) {
  const [data,      setData]     = useState([]);
  const [totD,      setTotD]     = useState(0);
  const [totC,      setTotC]     = useState(0);
  const [loading,   setLoading]  = useState(false);
  const [selected,  setSelected] = useState(null);
  const [modal,     setModal]    = useState(null);
  const [form,      setForm]     = useState(EMPTY);
  const formRef = useRef(EMPTY);   // آخرین مقدار فرم برای تصمیم‌هایی که بیرون از setForm گرفته می‌شوند
  formRef.current = form;
  const [saving,    setSaving]   = useState(false);
  const [error,     setError]    = useState('');
  const [toast,     setToast]    = useState('');
  const [colW,      setColW]     = useState(COLS.map(c=>c.w));
  const colWRef = useRef(colW);
  useEffect(()=>{ colWRef.current = colW; }, [colW]);
  const isLocked = !!doc.is_closed;
  // آخرین مبلغ و آخرین شرح وارد شده — با F12 دوباره نشانده می‌شوند
  const lastAmount = useRef('');
  const lastRemark = useRef('');
  const debitRef   = useRef(null);
  const creditRef  = useRef(null);
  const scInputRef = useRef(null);
  // پرسش تأیید سرور (مغایرت ماهیت حساب با مانده)
  const [ask, setAsk] = useState(null);
  // سرآیند سند از سرور: مبلغ مرجع، قرارداد سند، قفل ریز سپرده، حواله وابسته
  const [head, setHead] = useState({refrence_amount:0, contract_id:0, contract_display:'', deposit_lock:false, havaleh:''});
  // پنجرهٔ Black List و انتخاب شرح آماده (F1)
  const [blOpen, setBlOpen] = useState(null);
  const [rmOpen, setRmOpen] = useState(false);
  const [rmQ, setRmQ] = useState('');
  const [rmRows, setRmRows] = useState([]);
  const [warn, setWarn] = useState('');
  // دکمه‌های ردیف‌بندی و درج ردیف قبل (دیدن = دسترسی)
  const rowBtns = useFormButtons('FRMDOCUMENTDETAIL', ['BTNMAKESERIAL', 'BTNINSERTROWBEFORE']);
  const [stmt, setStmt] = useState(null);      // فهرست صورت وضعیت‌های قرارداد قلم
  const [summary, setSummary] = useState(null); // خلاصه به تفکیک معین
  // دریافت و پرداخت: match = وصل کردن قلم ثبت‌شده ، receive = برداشتن مبلغ در ثبت/ویرایش قلم
  const [io, setIo] = useState(null);           // {mode, rows}
  const [recvCount, setRecvCount] = useState(0);
  useEffect(() => {
    if (modal !== 'new' && modal !== 'edit') return;
    const code = si(form.sub_coding_code);
    if (!code) { setRecvCount(0); return; }
    let alive = true;
    API(`/document-details/inout-receive/?sub_coding=${code}&year=${year}`)
      .then(j => { if (alive) setRecvCount(j && j.ok ? j.count : 0); });
    return () => { alive = false; };
  }, [modal, form.sub_coding_code, year]); // eslint-disable-line

  /* مجوز دکمه‌ها — BTNNEW / BTNEDIT / BTNDELETE */
  // تا جواب سرور نیامده همه بسته است (دیدن = دسترسی)
  const [perms, setPerms] = useState({can_add:false,can_edit:false,can_delete:false,can_group_delete:false,can_ok:false});
  useEffect(()=>{ (async()=>{
    const j = await API('/detail-permissions/');
    if (j && j.ok) setPerms({can_add:!!j.can_add,can_edit:!!j.can_edit,can_delete:!!j.can_delete,
                             can_group_delete: !!j.can_group_delete, can_ok: !!j.can_ok});
  })(); },[]);

  /* لوکاپ حساب معین + فرم تفصیلی */
  const [scSearch,    setScSearch]    = useState('');
  const [scResults,   setScResults]  = useState([]);
  const [scDropOpen,  setScDropOpen] = useState(false);
  const [scConfig,    setScConfig]   = useState(null);   // config فیلدهای فعال
  const [scConfigLoading, setScConfigLoading] = useState(false);
  const scTimer = useRef(null);

  /* ── حذف گروهی اقلام ──
     دکمه دو حالته است: «حذف گروهی اقلام» → «حذف اقلام انتخابی»؛ در حالت دوم
     با چک‌باکس ستون اول چند قلم انتخاب می‌شود. */
  const [multi,     setMulti]     = useState(false);
  const [picked,    setPicked]    = useState([]);
  const [groupAsk,  setGroupAsk]  = useState(null);   // پرسش سه‌گزینه‌ای

  /* ── حساب ذینفع + فرم «حساب پیمانکار» ── */
  const [raOpen,    setRaOpen]    = useState(false);
  const [raData,    setRaData]    = useState(null);
  const [raLoading, setRaLoading] = useState(false);
  const [raForm,    setRaForm]    = useState(null);
  const [raSaving,  setRaSaving]  = useState(false);
  const [raErr,     setRaErr]     = useState('');

  /* پاپ‌آپ تفصیلی‌های حساب معین */
  const [scfOpen,    setScfOpen]    = useState(false);
  const [scfData,    setScfData]    = useState(null);
  const [scfLoading, setScfLoading] = useState(false);

  const openSubCodingFields = async (row) => {
    if (!row || !row.sub_coding_code) return;
    setScfLoading(true); setScfOpen(true); setScfData(null);
    const j = await API(`/sub-coding-attributes/${row.sub_coding_code}/${row.year || year}/`);
    setScfLoading(false);
    if (j.ok) setScfData({...j, _row: row});
    else { setScfData(null); setError(j.msg || 'خطا'); setScfOpen(false); }
  };

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),3000); };

  /* ── جستجوی حساب معین ── */
  const searchSubCoding = async (q) => {
    if (!q || q.length < 1) { setScResults([]); setScDropOpen(false); return; }
    const j = await API(`/sub-coding-search/?q=${encodeURIComponent(toEng(q))}&year=${year}`);
    if (!j.ok || !j.data || j.data.length === 0) { setScResults([]); setScDropOpen(false); return; }
    /* یک نتیجه = انتخاب خودکار: فهرست بسته، مقدار گذاشته و فوکوس به کادر بعد می‌رود. */
    if (j.data.length === 1) { selectSubCodingRef.current(j.data[0]); return; }
    setScResults(j.data); setScDropOpen(true);
  };

  const handleScSearchChange = (val) => {
    setScSearch(val);
    if (scTimer.current) clearTimeout(scTimer.current);
    if (!val) { setScResults([]); setScDropOpen(false); return; }
    scTimer.current = setTimeout(() => searchSubCoding(val), 300);
  };

  /* لود تنظیمات فرم از حساب معین */
  const loadFormConfig = async (code, isNew) => {
    if (!code) { setScConfig(null); return; }
    setScConfigLoading(true);
    const j = await API(`/sub-coding-form-config/${toEng(String(code))}/${year}/`);
    setScConfigLoading(false);
    if (j.ok) {
      setScConfig(j);
      // قلم جدید → پر کردن پیش‌فرض‌ها
      if (isNew && j.fields) {
        setForm(f => {
          const updated = { ...f };
          for (const fld of j.fields) {
            if (fld.default && fld.default !== 0) {
              updated[fld.field] = fld.default;
            }
          }
          if (j.defaults) {
            if (j.defaults.plan_id) updated.plan_id = j.defaults.plan_id;
            if (j.defaults.plan_detail_id) updated.plan_detail_id = j.defaults.plan_detail_id;
            if (j.defaults.shomool) updated.shomool = j.defaults.shomool;
            if (j.defaults.year) updated.year = String(j.defaults.year);
            if (j.defaults.treasury_document_id) updated.treasury_document_id = j.defaults.treasury_document_id;
          }
          // شماره‌حساب بانکِ این معین را خودکار پر کن
          if (j.account_code) {
            updated.account_code = j.account_code;
            updated.account_code_display = j.account_display || '';
          }
          return updated;
        });
      }
    } else {
      setScConfig(null);
    }
  };

  /* ── انتخاب حساب معین از لیست ── */
  const selectSubCoding = (item) => {
    setScDropOpen(false);
    setScSearch('');
    setForm(f => ({ ...f, sub_coding_code: String(item.code) }));
    loadFormConfig(item.code, modal === 'new');
  };
  const selectSubCodingRef = useRef(selectSubCoding);
  selectSubCodingRef.current = selectSubCoding;

  const load = useCallback(async () => {
    setLoading(true); setError('');
    const j = await API(`/documents/${doc.id}/details/?year=${year}`);
    setLoading(false);
    if (j.ok) {
      setData(j.data); setTotD(j.total_debit); setTotC(j.total_credit);
      if (j.head) setHead(j.head);
      setSelected(sl => sl ? (j.data.find(x => x.id === sl.id) || null) : sl);
    }
    else setError(j.msg);
  },[doc.id,year]);

  useEffect(()=>{ load(); },[]);// eslint-disable-line

  const hf = e => {
    const {name,value,type,checked} = e.target;
    setForm(f=>({...f,[name]:type==='checkbox'?checked:value}));
  };

  const nextPaper = () => data.reduce((m, r) => Math.max(m, r.paper_no || 0), 0) + 1;
  // قفل مبالغ در ویرایش: قلم ثبت‌شده در دریافت و پرداخت (حساب معین هم قفل)، یا سندی که قلمش در ریز سپرده است
  const lockReason = modal === 'edit' && selected
    ? (selected.inout_lock ? 'بدلیل ثبت این آرتیکل در دریافت و پرداخت، ویرایش مبالغ امکانپذیر نیست'
       : head.deposit_lock ? 'بدلیل وجود سپرده ویرایش مبالغ امکانپذیر نیست' : '')
    : '';
  const amountsLocked = !!lockReason || !!form._amount_from_inout;
  const subCodingLocked = modal === 'edit' && !!(selected && selected.inout_lock);

  const makeSerial = async () => {
    if (isLocked) return;
    const j = await API(`/documents/${doc.id}/details/make-serial/`, { method: 'POST' });
    if (j.ok) { showToast(j.msg); load(); } else setError(j.msg);
  };
  // درج ردیف قبل: ردیف‌های بعدی جلو می‌روند و فرم قلم جدید با همان ردیف باز می‌شود
  const insertBefore = async () => {
    if (isLocked || !selected || !perms.can_add) return;
    const paper = selected.paper_no;
    const j = await API(`/documents/${doc.id}/details/insert-before/`, { method: 'POST', body: JSON.stringify({ paper_no: paper }) });
    if (!j.ok) { setError(j.msg); return; }
    await load();
    openNew(); setForm(f => ({ ...f, paper_no: String(paper) }));
  };
  // اتصال قلم ثبت‌شده به دریافت و پرداخت: فقط قلمی که هنوز شماره دریافت و پرداخت ندارد،
  // معینش «ارسال به دریافت و پرداخت» دارد و فرمی باز نیست
  const canInOutMatch = r => !!r && !modal && !r.inout_lock && !(r.inout_number || '').trim() && r.send_to_inout === 1;
  const openInOutMatch = async () => {
    if (!canInOutMatch(selected)) return;
    const j = await API(`/document-details/${selected.id}/inout-match/`, { method: 'POST', body: JSON.stringify({ action: 'search' }) });
    if (!j.ok) { setError(j.msg); return; }
    if (!j.allowed) return;
    if (!j.data || j.data.length === 0) { if (j.msg) setError(j.msg); return; }
    setIo({ mode: 'match', rows: j.data });
  };
  const pickInOutMatch = async (r) => {
    if (!window.confirm('آيا مطمئن هستيد؟')) return;
    const j = await API(`/document-details/${selected.id}/inout-match/`, { method: 'POST', body: JSON.stringify({ action: 'link', detail_id: r.detail_id }) });
    setIo(null);
    if (j.ok) { showToast(j.msg); load(); } else setError(j.msg);
  };
  // دریافت از دریافت و پرداخت در فرم قلم: مبلغ از ریز انتخابی می‌آید و قفل می‌شود
  const openInOutReceive = async () => {
    const j = await API(`/document-details/inout-receive/?sub_coding=${si(form.sub_coding_code)}&year=${year}`);
    if (!j.ok) { setError(j.msg); return; }
    if (!j.data || j.data.length === 0) { setError('اطلاعاتی برای دریافت وجود ندارد'); return; }
    setIo({ mode: 'receive', rows: j.data });
  };
  const pickInOutReceive = (r) => {
    setForm(f => ({ ...f, debit: String(r.debit || ''), credit: String(r.credit || ''),
                    inout_detail_id: r.id, _amount_from_inout: true }));
    setIo(null);
  };

  const canStatement = r => r && !r.contractor_statement_id && [21001, 24007].includes(r.sub_coding_code) && r.contract_id > 0;
  const openStatements = async () => {
    if (!canStatement(selected)) return;
    const j = await API(`/document-details/${selected.id}/statement/`);
    if (j.ok) setStmt(j.data || []); else setError(j.msg);
  };
  const pickStatement = async (sid) => {
    const j = await API(`/document-details/${selected.id}/statement/`, { method: 'POST', body: JSON.stringify({ statement_id: sid }) });
    setStmt(null);
    if (j.ok) { showToast(j.msg); load(); } else setError(j.msg);
  };
  const openSummary = async (side) => {
    const j = await API(`/documents/${doc.id}/details/summary/?side=${side}`);
    if (j.ok) setSummary({ side, rows: j.data || [] }); else setError(j.msg);
  };

  const openNew = () => {
    if (isLocked) return;
    setForm({...EMPTY, shomool:1, financial_year:year, paper_no: String(nextPaper())});
    setScConfig(null); setScSearch(''); setScDropOpen(false);
    setError(''); setAsk(null); setWarn(''); setModal('new');
  };

  const openEdit = (rowArg) => {
    const r = rowArg || selected;
    if (!r||isLocked) return;
    setForm({
      sub_coding_code: String(r.sub_coding_code||''),
      remark: r.remark, debit: String(r.debit||''), credit: String(r.credit||''),
      year: String(r.year||year), fasl: String(r.fasl||''),
      program_id: r.program_id, project_id: r.project_id, plan_id: r.plan_id,
      plan_detail_id: r.plan_detail_id||0,
      expense_article_id: r.expense_article_id||0,
      expense_detail_article_id: r.expense_detail_article_id||0,
      expense_part_id: r.expense_part_id||0,
      expense_kind_id: r.expense_kind_id||0,
      construct_article_id: r.construct_article_id||0,
      nominee_id: r.nominee_id, people_id: r.people_id,
      amount_receiver_id: r.amount_receiver_id,
      contract_id: r.contract_id,
      debenture_sender_id: r.debenture_sender_id||0,
      debenture_receiver_id: r.debenture_receiver_id||0,
      cost_center_id: r.cost_center_id||0,
      vouch_type_group_id: r.vouch_type_group_id||0,
      account_code: r.account_code||0, credit_id: r.credit_id||0,
      income_id: r.income_id||0,
      source_type: r.source_type, source_essence: r.source_essence,
      other_source_type: r.other_source_type||0,
      credit_type: r.credit_type, transferal_type: r.transferal_type,
      transfer_items: r.transfer_items||0, credit_info: r.credit_info||0,
      rank_id: r.rank_id||0, sub_budget_id: r.sub_budget_id||0,
      income_type: r.income_type||0, other_income_type: r.other_income_type||0,
      governmental: r.governmental, allocation_source: r.allocation_source,
      tax_season: r.tax_season, award_article: r.award_article||0,
      securities_type: r.securities_type||0,
      guarantee_essence: r.guarantee_essence||0,
      demand_status: r.demand_status||0, temp_payment_type: r.temp_payment_type||0,
      leakage_subject: r.leakage_subject||0,
      receivables_subject: r.receivables_subject||0,
      assurance_type: r.assurance_type||0, assurance_subject: r.assurance_subject||0,
      currency_type: r.currency_type||0, insurance_type: r.insurance_type||0,
      debit_subject: r.debit_subject||0, fixed_asset_type: r.fixed_asset_type||0,
      inventory_type: r.inventory_type||0, quantity: r.quantity||0,
      due_date: r.due_date||'', investment_type: r.investment_type||0,
      annual_adjustments: r.annual_adjustments||0,
      decrese_credit: !!r.decrese_credit, shomool: r.shomool||0,
      treasury_document_id: r.treasury_document_id||0,
      account_coding_code: r.account_coding_code||0,
      contractor_statement_id: r.contractor_statement_id||0,
      paper_no: String(r.paper_no||''),
      financial_year: year,
    });
    setScSearch(''); setScDropOpen(false);
    // ویرایش — بدون پر کردن defaults
    if (r.sub_coding_code) loadFormConfig(r.sub_coding_code, false);
    setError(''); setAsk(null); setWarn('');
    // سندی که به تامین اعتبار وابسته است: فقط اطلاع داده می‌شود
    if (head.havaleh) showToast('این سند به تامین اعتبار وابسته بوده و اقلام آن قابل ویرایش نیستند — برای حذف کلیه اقلام آن از حذف گروهی اقلام استفاده کنید');
    setModal('edit');
  };

  const save = async (confirmed = false) => {
    if (saving) return;
    if (!form.sub_coding_code) { setError('کد حساب معین الزامی است'); return; }
    // بدهکار و بستانکار نمی‌توانند هردو غیرصفر باشند
    if (!si(form.debit) && !si(form.credit)) { setError('اطلاعات کامل نیست'); return; }
    if (si(form.debit) && si(form.credit)) {
      setError('مبلغ بدهکار و بستانکار نمیتوانند هردو غیر صفر باشند'); return;
    }
    // ستارهٔ تفصیلی‌ها فقط علامت است و ذخیره را قفل نمی‌کند.
    // کنترل‌های واقعی (پرداخت غیرقطعی / نوع سایر منابع / ابلاغ دهنده) در سرور
    // انجام می‌شود و پیامش همین‌جا نمایش داده می‌شود.
    setSaving(true); setError('');
    const payload = {
      ...form,
      sub_coding_code: si(form.sub_coding_code),
      account_coding_code: Math.floor(si(form.sub_coding_code)/1000)||0,
      debit: si(form.debit), credit: si(form.credit),
      year: si(form.year)||year, fasl: si(form.fasl), paper_no: si(form.paper_no),
      financial_year: year,
      confirmed: confirmed ? 1 : 0,
    };
    const j = modal==='new'
      ? await API(`/documents/${doc.id}/details/create/`,{method:'POST',body:JSON.stringify(payload)})
      : await API(`/document-details/${selected.id}/update/`,{method:'PUT',body:JSON.stringify(payload)});
    setSaving(false);
    if (j.needs_confirm) { setAsk(j.msg); return; }
    setAsk(null);
    if (!j.ok) { setError(j.msg); return; }
    lastRemark.current = form.remark || lastRemark.current;
    setWarn(j.warning || '');
    showToast(j.warning ? `${j.msg} — ${j.warning}` : j.msg); load();
    if (modal === 'new') {
      // ثبت پشت‌سرهم: فرم برای قلم بعدی خالی می‌شود؛ قرارداد و منبع اعتبار مثل قبل می‌ماند
      setForm(f => ({ ...EMPTY, shomool: 1, financial_year: year, paper_no: String(Math.max(si(f.paper_no), nextPaper()) + 1),
        contract_id: f.contract_id, contract_id_display: f.contract_id_display,
        credit_id: f.credit_id, credit_id_display: f.credit_id_display }));
      setScConfig(null); setScSearch(''); setError('');
      setTimeout(() => scInputRef.current && scInputRef.current.focus(), 50);
    } else { setModal(null); setSelected(null); }
  };

  /* کلیدهای میان‌بر فرم قلم: Insert ثبت ، Escape انصراف ، F12 آخرین مبلغ/شرح */
  const amountKeys = name => e => {
    if (e.key === 'F12') { e.preventDefault(); if (lastAmount.current) setForm(f => ({ ...f, [name]: lastAmount.current })); }
    // F11: مبلغ واردشده درصدی از مبلغ مرجع سند است
    else if (e.key === 'F11') { e.preventDefault();
      setForm(f => ({ ...f, [name]: String(Math.round((head.refrence_amount || 0) * si(f[name]) / 100)) })); }
    else if (e.key === 'Insert') { e.preventDefault(); save(); }
    else if (e.key === 'Escape') { e.preventDefault(); setModal(null); }
  };
  const remarkKeys = e => {
    if (e.key === 'F12') { e.preventDefault(); if (lastRemark.current) setForm(f => ({ ...f, remark: lastRemark.current })); }
    // F1: انتخاب شرح آماده با کد؛ متن آن به انتهای شرح اضافه می‌شود
    else if (e.key === 'F1') { e.preventDefault(); setRmQ(''); setRmRows([]); setRmOpen(true); loadRemarks(''); }
    else if (e.key === 'Insert') { e.preventDefault(); save(); }
    else if (e.key === 'Escape') { e.preventDefault(); setModal(null); }
  };
  const loadRemarks = async (q) => {
    setRmQ(q);
    const j = await API(`/remark-code/?q=${encodeURIComponent(toEng(q))}`);
    if (j.ok) setRmRows(j.data || []); else { setRmOpen(false); setError(j.msg); }
  };
  const pickRemark = async (code) => {
    const j = await API(`/remark-code/?code=${si(code)}`);
    setRmOpen(false);
    if (j.ok && j.remark) setForm(f => ({ ...f, remark: `${(f.remark || '').trim()} ${j.remark}`.trim() }));
  };
  /* «حساب گیرنده» در فرم قلم — با انتخاب پیمانکار / گیرندهٔ وجه / شخص به‌روز می‌شود */
  const [rcvAccount, setRcvAccount] = useState('');
  const f12Nominee = useRef(0);   // ذینفعی که با F12 نشسته و حسابش از خود پیمانکار آمده
  useEffect(() => {
    if (modal !== 'new' && modal !== 'edit') return;
    const nominee = si(form.nominee_id), people = si(form.people_id), receiver = si(form.amount_receiver_id);
    if (nominee && nominee === f12Nominee.current) return;
    f12Nominee.current = 0;
    if (!nominee && !people && !receiver) { setRcvAccount(''); return; }
    let alive = true;
    API(`/documents/${doc.id}/receiver-account/?nominee=${nominee}&people=${people}&receiver=${receiver}&contract=${si(form.contract_id)}`)
      .then(j => { if (alive && j.ok) setRcvAccount(j.account || ''); });
    return () => { alive = false; };
  }, [modal, form.nominee_id, form.people_id, form.amount_receiver_id, form.contract_id, doc.id]); // eslint-disable-line

  // نشاندن پیمانکار قرارداد سرسند و شماره حساب — هم با F12 و هم با کلیک
  const applyNomineeFromContract = async (setLabel) => {
    if (form._nominee_locked) return;
    const j = await API(`/documents/${doc.id}/receiver-account/?f12=1`);
    if (!j.ok || !j.nominee_id) return;
    f12Nominee.current = j.nominee_id;
    if (setLabel) setLabel(j.nominee_name || '');
    setForm(f => ({ ...f, nominee_id: j.nominee_id, nominee_id_display: j.nominee_name || '',
      people_id: 0, amount_receiver_id: 0, _nominee_from_contract: false }));
    setRcvAccount(j.account || '');
  };
  const nomineeKeys = async (e, setLabel) => {
    if (e.key !== 'F12') return;
    e.preventDefault();
    applyNomineeFromContract(setLabel);
  };

  // F12 در کادر قرارداد: قرارداد خود سند
  const contractKeys = (e, setLabel) => {
    if (e.key !== 'F12') return;
    e.preventDefault();
    if (!head.contract_id) return;
    applyContract({ id: head.contract_id, label: head.contract_display }, false, setLabel);
  };
  // قرارداد ← پیمانکار: انتخاب از فهرست همیشه پیمانکار قرارداد را می‌نشاند و آن را قفل می‌کند؛
  // انتخاب خودکارِ تنها نتیجه فقط وقتی که طرف‌حسابی انتخاب نشده باشد
  const applyContract = async (r, auto, setLabel) => {
    let code = r.contractor_code, name = r.contractor_name;
    if (code === undefined) {
      const j = await API(`/detail-lookup/?field=contract_id&q=${encodeURIComponent(toEng(String(r.label||'').split(' ')[0]))}&year=${year}`);
      const hit = j.ok && (j.data || []).find(x => x.id === r.id);
      code = hit ? hit.contractor_code : 0; name = hit ? hit.contractor_name : '';
    }
    if (setLabel) setLabel(r.label || '');
    // تصمیم یک‌بار و روی آخرین مقدار فرم گرفته می‌شود تا پیام و کادر پیمانکار همیشه یکی باشند
    const cur = formRef.current;
    // پیمانکاری که خودش از قرارداد قبلی آمده «انتخاب کاربر» حساب نمی‌شود و با قرارداد جدید عوض می‌شود
    const hasParty = !!((si(cur.nominee_id) && !cur._nominee_from_contract) || si(cur.people_id) || si(cur.amount_receiver_id));
    const fill = !!code && (!auto || !hasParty);
    setForm(f => {
      const nf = { ...f, contract_id: r.id, contract_id_display: r.label || '' };
      if (fill) {
        nf.nominee_id = code; nf.nominee_id_display = name || '';
        nf.people_id = 0; nf.amount_receiver_id = 0;
        nf._nominee_from_contract = true;
        if (!auto) nf._nominee_locked = true;
      }
      return nf;
    });
    if (fill && name) showToast(`پیمانکار قرارداد: ${name}`);
  };

  // قلم جدیدی که قرارداد قلم قبلی را نگه داشته: وقتی فرم حساب معین آمد و کادر پیمانکار دارد
  // و طرف‌حسابی انتخاب نشده، پیمانکار همان قرارداد در کادر نشانده می‌شود (همان که موقع ثبت ذخیره می‌شود)
  useEffect(() => {
    if (modal !== 'new' || !fieldHasNominee(scConfig)) return;
    const cur = formRef.current;
    if (!si(cur.contract_id) || (si(cur.nominee_id) && !cur._nominee_from_contract) || si(cur.people_id) || si(cur.amount_receiver_id)) return;
    applyContract({ id: si(cur.contract_id), label: cur.contract_id_display || '' }, true);
  }, [scConfig, modal]); // eslint-disable-line

  // بدهکار و بستانکار با هم پر نمی‌شوند: ورود به یکی وقتی دیگری مبلغ دارد آن را خالی می‌کند
  const debitFocus = () => {
    if (si(form.credit) > 0) { setForm(f => ({ ...f, debit: '' })); setTimeout(() => creditRef.current && creditRef.current.focus(), 0); }
  };
  const creditFocus = () => { if (si(form.debit) > 0) setForm(f => ({ ...f, credit: '' })); };
  const amountBlur = name => () => { if (si(form[name]) !== 0) lastAmount.current = String(si(form[name])); };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/document-details/${selected.id}/delete/`,{method:'DELETE'});
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('قلم حذف شد'); load(); }
    else setError(j.msg);
  };

  /* ── حذف گروهی اقلام ──────────────────────────────────────────────────
     گام اول: دکمه به «حذف اقلام انتخابی» تبدیل و انتخاب چندتایی فعال می‌شود.
     گام دوم: تأیید و حذف. */
  const toggleMulti = () => {
    if (isLocked) return;
    if (!multi) { setMulti(true); setPicked([]); setSelected(null);
                  showToast('اقلام مورد نظر برای حذف را انتخاب کنید'); return; }
    if (picked.length === 0) { setError('هیچ آرتیکلی انتخاب نشده است'); return; }
    setError(''); setModal('group-delete');
  };

  const cancelMulti = () => { setMulti(false); setPicked([]); setGroupAsk(null); };

  const togglePick = (id) => setPicked(p =>
    p.includes(id) ? p.filter(x => x !== id) : [...p, id]);

  const doGroupDelete = async (mode) => {
    // mode: 'picked' = فقط اقلام انتخاب شده ، 'all' = همه اقلام سند
    setSaving(true); setError('');
    const body = mode === 'all'
      ? { all: 1, confirmed: 1 }
      : { ids: picked, confirmed: groupAsk ? 1 : 0 };
    let j;
    try {
      j = await API(`/documents/${doc.id}/details/delete-group/`,
                    { method:'POST', body: JSON.stringify(body) });
    } catch (e) {
      j = { ok: false, msg: 'ارتباط با سرور برقرار نشد' };
    }
    setSaving(false);
    if (j.needs_confirm) {           // پرسش سه‌گزینه‌ای
      setModal(null); setGroupAsk({ msg: j.msg }); return;
    }
    // پیام خطا (محافظ چک/فیش، ریز سپرده، سند دائم، مجوز) باید دیده شود: پنجره بسته
    // می‌شود تا کادر خطای بالای جدول پشت آن پنهان نماند.
    if (!j.ok) { setModal(null); setGroupAsk(null); setError(j.msg || 'حذف انجام نشد'); return; }
    setModal(null); setGroupAsk(null); cancelMulti();
    showToast(j.msg); load();
  };

  /* ── حساب ذینفع ───────────────────────────────────────────────────────
     شماره حساب ذینفع روی قلم فقط خواندنی است. اصلاح حساب پیمانکار همان
     کارهای فرم «حساب پیمانکار» است و فقط برای کسی که مجوز آن را دارد:
     حساب عمومی از مسیر پیمانکاران، حساب قرارداد از مسیر قراردادها. */
  const openReceiverAccounts = async (row) => {
    const r = row || selected;
    if (!r) return;
    setRaOpen(true); setRaLoading(true); setRaData(null); setRaForm(null); setRaErr('');
    const j = await API(`/document-details/${r.id}/receiver-accounts/`);
    setRaLoading(false);
    if (j.ok) setRaData({ ...j, _row: r });
    else { setRaErr(j.msg || 'خطا'); }
  };

  const newReceiverAccount = (scope) => setRaForm({
    id: 0, scope,
    letter_no: '', letter_date: todayFa(), account_no: '', branch_code: 0, branch_display: '',
  });

  const editReceiverAccount = (a) => {
    if (!a.can_edit) { setRaErr(a.scope_note || 'شما دسترسی لازم برای این عملیات را ندارید.'); return; }
    setRaErr('');
    setRaForm({
      id: a.id, scope: a.contract_id ? 'contract' : 'general',
      letter_no: a.letter_no, letter_date: a.letter_date, account_no: a.account_no,
      branch_code: a.branch_code, branch_display: a.bank,
    });
  };

  const afterAccountChange = (msg) => {
    showToast(msg);
    openReceiverAccounts(raData._row);
    load();                       // ستون «حساب گیرنده» در گرید به‌روز شود
  };

  const saveReceiverAccount = async (confirmed) => {
    setRaSaving(true); setRaErr('');
    const body = { ...raForm, detail_id: raData._row.id, confirmed: confirmed ? 1 : 0 };
    const j = raForm.id
      ? await API(`/receiver-accounts/${raForm.id}/update/`, {method:'PUT',  body:JSON.stringify(body)})
      : await API('/receiver-accounts/create/',              {method:'POST', body:JSON.stringify(body)});
    setRaSaving(false);
    if (j.needs_confirm) {
      if (window.confirm(j.msg)) return saveReceiverAccount(true);
      return;
    }
    if (!j.ok) { setRaErr(j.msg); return; }
    setRaForm(null);
    afterAccountChange(j.msg);
  };

  const deleteReceiverAccount = async (a) => {
    if (!a.can_delete) { setRaErr(a.scope_note || 'شما دسترسی لازم برای این عملیات را ندارید.'); return; }
    if (!window.confirm('آيا از حذف مطمئن هستيد؟')) return;
    setRaErr('');
    const j = await API(`/receiver-accounts/${a.id}/delete/?detail_id=${raData._row.id}`, {method:'DELETE'});
    if (!j.ok) { setRaErr(j.msg); return; }
    afterAccountChange(j.msg);
  };

  const shebaReceiverAccount = async (a) => {
    if (!window.confirm('شماره حساب شبا محاسبه شود؟')) return;
    setRaErr('');
    const j = await API(`/receiver-accounts/${a.id}/sheba/`,
      {method:'POST', body:JSON.stringify({detail_id: raData._row.id})});
    if (!j.ok) { setRaErr(j.msg); return; }
    afterAccountChange(j.msg);
  };

  const startResize = useCallback((idx,e)=>{
    e.preventDefault();
    e.stopPropagation();
    const sx = e.clientX;
    const sw = colWRef.current[idx];
    const onMove = ev => {
      const newW = Math.max(40, sw + (sx - ev.clientX));
      setColW(w => { const n=[...w]; n[idx]=newW; return n; });
    };
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  }, []);

  const cell = (r,c) => {
    const v = r[c.k];
    if (c.num) return v>0?numFmt(v):'•';
    if (c.k==='decrese_credit') return v?'✓':'';
    return v||'—';
  };

  const locked_tip = isLocked?'سند دائمی است — امکان تغییر وجود ندارد':'';

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e=>e.stopPropagation()}>

        {/* هدر */}
        <div style={s.mHeader}>
          <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
            <span style={{fontSize:'15px',fontWeight:'700',color:'#fff'}}>
              📋 اقلام سند {toFa(doc.document_no)} — {doc.document_date}
            </span>
            <span style={{fontSize:'11px',color:'rgba(255,255,255,0.6)'}}>
              {doc.document_remark}
            </span>
            {head.havaleh && (
              <span style={{fontSize:'11px',color:'#ffe082'}}>{toFa(head.havaleh)}</span>
            )}
            {isLocked && (
              <span style={{background:'#e65100',color:'#fff',padding:'2px 8px',
                borderRadius:'4px',fontSize:'11px',fontWeight:'700'}}>
                🔒 سند دائم
              </span>
            )}
          </div>
          <button onClick={onClose} style={s.closeBtn}>✕</button>
        </div>

        {/* نوار ابزار */}
        <div style={s.toolbar}>
          <div style={{display:'flex',gap:'7px'}}>
            {perms.can_add && (
            <button onClick={openNew} disabled={isLocked}
              title={locked_tip}
              style={{...s.btnNew,opacity:isLocked?.4:1,cursor:isLocked?'not-allowed':'pointer'}}>
              ＋ جدید
            </button>)}
            {perms.can_edit && (
            <button onClick={()=>openEdit()} disabled={!selected||isLocked}
              title={!selected?'ابتدا یک سطر انتخاب کنید':locked_tip}
              style={{...s.btnEdit,opacity:(!selected||isLocked)?.4:1,cursor:(!selected||isLocked)?'not-allowed':'pointer'}}>
              ✎ ویرایش
            </button>)}
            {perms.can_delete && (
            <button onClick={()=>{if(!selected||isLocked)return;setError('');setModal('delete');}}
              disabled={!selected||isLocked}
              title={!selected?'ابتدا یک سطر انتخاب کنید':locked_tip}
              style={{...s.btnDel,opacity:(!selected||isLocked)?.4:1,cursor:(!selected||isLocked)?'not-allowed':'pointer'}}>
              ✕ حذف
            </button>)}
            {/* حذف گروهی مجوز دکمهٔ جدا ندارد (فقط مجوز فرم اقلام سند) */}
            {perms.can_group_delete && (
            <button onClick={toggleMulti} disabled={isLocked}
              title={isLocked?locked_tip:'حذف چند قلم با هم'}
              style={{...s.btnDel,
                background:multi?'linear-gradient(135deg,#e65100,#ef6c00)':s.btnDel.background,
                opacity:isLocked?.4:1,cursor:isLocked?'not-allowed':'pointer'}}>
              {multi?`🗑 حذف اقلام انتخابی (${toFa(picked.length)})`:'☑ حذف گروهی اقلام'}
            </button>)}
            {multi && (
            <button onClick={cancelMulti} style={s.btnCancel}>انصراف از انتخاب</button>)}
            <span style={{width:'1px',height:'24px',background:'#e0e0e0',margin:'0 4px'}}/>
            <button onClick={()=>openSubCodingFields(selected)}
              disabled={!selected}
              title={!selected?'ابتدا یک سطر انتخاب کنید':'نمایش تفصیلی‌های ثبت‌شدهٔ این قلم — فقط نمایش'}
              style={{...s.btnScf,opacity:!selected?.4:1,cursor:!selected?'not-allowed':'pointer'}}>
              📋 تفصیلی‌های این قلم
            </button>
            <button onClick={()=>openReceiverAccounts(selected)}
              disabled={!selected}
              title={!selected?'ابتدا یک سطر انتخاب کنید':'شماره حساب ذینفع و اصلاح آن'}
              style={{...s.btnScf,background:'linear-gradient(135deg,#4527a0,#5e35b1)',
                opacity:!selected?.4:1,cursor:!selected?'not-allowed':'pointer'}}>
              🏦 حساب ذینفع
            </button>
            {rowBtns.can('BTNINSERTROWBEFORE') && perms.can_add && data.length > 0 && (
              <button onClick={insertBefore} disabled={!selected||isLocked}
                style={{...s.btnScf,background:'linear-gradient(135deg,#00695c,#00897b)',opacity:(!selected||isLocked)?.4:1}}>
                ⤒ درج ردیف قبل
              </button>
            )}
            {rowBtns.can('BTNMAKESERIAL') && data.length > 0 && (
              <button onClick={makeSerial} disabled={isLocked}
                style={{...s.btnScf,background:'linear-gradient(135deg,#455a64,#607d8b)',opacity:isLocked?.4:1}}>
                ۱۲۳ ردیف‌بندی
              </button>
            )}
            {canInOutMatch(selected) && (
              <button onClick={openInOutMatch}
                title="وصل کردن این قلم به دریافت و پرداختی با همین مبلغ"
                style={{...s.btnScf,background:'linear-gradient(135deg,#37474f,#546e7a)'}}>
                🔗 دریافت و پرداخت
              </button>
            )}
            {canStatement(selected) && (
              <button onClick={openStatements}
                style={{...s.btnScf,background:'linear-gradient(135deg,#6a1b9a,#8e24aa)'}}>
                📄 انتخاب صورت وضعیت
              </button>
            )}
            {selected && selected.black_list && (
              <button onClick={()=>setBlOpen({code: selected.nominee_id, name: selected.contractor_name})}
                title="مشاهدهٔ محدودیت‌های پیمانکار"
                style={{...s.btnScf,background:'linear-gradient(135deg,#7f0000,#c62828)'}}>
                ⛔ اخطار: این پیمانکار در Black List  قرار دارد
              </button>
            )}
          </div>
          <div style={{display:'flex',gap:'16px',alignItems:'center',marginRight:'auto'}}>
            <span onDoubleClick={()=>openSummary('debit')} title="دابل‌کلیک: خلاصه به تفکیک معین"
              style={{fontSize:'12px',fontWeight:'700',color:'#b71c1c',cursor:'pointer'}}>بدهکار: {numFmt(totD)}</span>
            <span onDoubleClick={()=>openSummary('credit')} title="دابل‌کلیک: خلاصه به تفکیک معین"
              style={{fontSize:'12px',fontWeight:'700',color:'#1b5e20',cursor:'pointer'}}>بستانکار: {numFmt(totC)}</span>
            <span onDoubleClick={()=>openSummary('')} title="دابل‌کلیک: خلاصه به تفکیک معین"
              style={{fontSize:'12px',fontWeight:'700',color:'#e65100',cursor:'pointer'}}>مانده: {numFmt(Math.abs(totD-totC))}</span>
          </div>
          <span style={{fontSize:'12px',color:'#777'}}>{toFa(data.length)} قلم</span>
        </div>

        {error && !modal && !scfOpen && <div style={s.errBox}>⚠️ {error}</div>}
        {selected && selected.inout_lock && (
          <div style={{display:'flex',gap:'18px',padding:'6px 14px',fontSize:'11px',color:'#37474f',
            background:'#eceff1',borderBottom:'1px solid #cfd8dc',flexWrap:'wrap'}}>
            <span>حساب: <b>{toFa(selected.inout_account)}</b></span>
            <span>شماره دریافت/پرداخت: <b>{toFa(selected.inout_number)}</b></span>
            <span>تاریخ دفتر: <b>{toFa(selected.inout_date)}</b></span>
            <span>تاریخ بانک: <b>{toFa(selected.inout_bank_date)}</b></span>
            <span>مبلغ: <b>{numFmt(selected.inout_amount)}</b></span>
          </div>
        )}

        {/* جدول */}
        <div style={s.tableWrap}>
          {loading
            ? <div style={{textAlign:'center',padding:'40px',color:'#999'}}>⏳ بارگذاری...</div>
            : (
              <table style={s.table}>
                <thead>
                  <tr>
                    {multi && (
                      <th style={{...s.th,width:34,minWidth:34,background:'#e65100'}}
                        title="انتخاب همه">
                        <input type="checkbox"
                          checked={data.length>0 && picked.length===data.length}
                          onChange={e=>setPicked(e.target.checked?data.map(r=>r.id):[])}/>
                      </th>
                    )}
                    {COLS.map((c,i)=>(
                      <th key={c.k} style={{
                        ...s.th, width:colW[i], minWidth:40,
                        textAlign:c.center?'center':c.right?'right':'center',
                        background:c.red?'#1a3a2a':c.grn?'#0d3020':'#1a2f50',
                        color:c.red?'#ef9a9a':c.grn?'#a5d6a7':'#fff',
                        position:'relative',
                      }}>
                        {c.l}
                        <span onMouseDown={e=>startResize(i,e)}
                          style={{position:'absolute',left:0,top:0,bottom:0,
                            width:'4px',cursor:'col-resize'}}/>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.length===0
                    ? <tr><td colSpan={COLS.length+(multi?1:0)} style={{textAlign:'center',padding:'40px',color:'#999'}}>📭 اقلامی ثبت نشده</td></tr>
                    : data.map((r,i)=>{
                        const sel=selected?.id===r.id;
                        const inoutDiff = r.inout_lock && r.inout_amount !== (r.debit||0) + (r.credit||0);
                        const noCheque  = (r.account_code||0) > 0 && !r.inout_number;
                        const bg=sel?'#1a2f50':inoutDiff?'#bc8f8f':noCheque?'#87ceeb':i%2===0?'#fff':'#fafafa';
                        const tc=sel?'#fff':'#111';
                        return (
                          <tr key={r.id}
                            style={{background:multi&&picked.includes(r.id)?'#fff3e0':bg,
                              cursor:'pointer',transition:'background .1s'}}
                            onClick={()=>multi?togglePick(r.id):setSelected(sel?null:r)}
                            onDoubleClick={()=>{if(multi)return;setSelected(r);openSubCodingFields(r);}}
                            onMouseEnter={e=>{if(!sel)e.currentTarget.style.background='#e8f0fe';}}
                            onMouseLeave={e=>{if(!sel)e.currentTarget.style.background=multi&&picked.includes(r.id)?'#fff3e0':bg;}}>
                            {multi && (
                              <td style={{...s.td,textAlign:'center'}}>
                                <input type="checkbox" checked={picked.includes(r.id)}
                                  onChange={()=>togglePick(r.id)} onClick={e=>e.stopPropagation()}/>
                              </td>
                            )}
                            {COLS.map((c,ci)=>(
                              <td key={c.k} style={{
                                ...s.td,
                                textAlign:c.center?'center':c.right?'right':'center',
                                color:c.red?(sel?'#ef9a9a':r.debit>0?'#b71c1c':'#ccc')
                                     :c.grn?(sel?'#a5d6a7':r.credit>0?'#1b5e20':'#ccc')
                                     :tc,
                                fontWeight:(c.red||c.grn)?'700':'400',
                                fontFamily:(c.red||c.grn)?'monospace':'inherit',
                                width:colW[ci],maxWidth:colW[ci],overflow:'hidden',
                                textOverflow:'ellipsis',whiteSpace:'nowrap',
                              }} title={String(r[c.k]||'')}>
                                {cell(r,c)}
                              </td>
                            ))}
                          </tr>
                        );
                      })
                  }
                </tbody>
              </table>
            )
          }
        </div>

        {/* پاورقی */}
        <div style={s.footer}>
          <span style={{fontSize:'12px',color:'#999'}}>سال: {toFa(year)}</span>
          <button onClick={onClose} style={s.btnClose}>بستن</button>
        </div>

        {/* پاپ‌آپ جدید/ویرایش */}
        {(modal==='new'||modal==='edit') && (
          <div style={s.innerOverlay} onClick={()=>{setModal(null);setScDropOpen(false);}}>
            <div style={{...s.innerModal,maxWidth:'820px'}} onClick={e=>{e.stopPropagation();setScDropOpen(false);}}>
              <div style={s.iHeader}>
                <span style={{fontSize:'14px',fontWeight:'700',color:'#fff'}}>
                  {modal==='new'?'＋ قلم جدید':`✎ ویرایش ردیف ${toFa(selected?.paper_no)}`}
                </span>
                {scConfig && (
                  <span style={{fontSize:'11px',color:'rgba(255,255,255,0.7)',marginRight:'10px'}}>
                    {scConfig.name} ({toFa(scConfig.code)}) — {scConfig.entity||''}
                  </span>
                )}
                <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
              </div>
              <div style={s.iBody}>
                {error && <div style={s.errBox}>⚠️ {error}</div>}
                {ask && (
                  <div style={{background:'#fff8e1',border:'1.5px solid #ffb300',borderRadius:'8px',
                    padding:'10px 14px',marginBottom:'10px',fontSize:'12px',color:'#5d4037',whiteSpace:'pre-line'}}>
                    ⚠️ {ask}
                    <div style={{display:'flex',gap:'8px',justifyContent:'flex-end',marginTop:'8px'}}>
                      <button onClick={()=>setAsk(null)} style={s.btnCancel}>خیر</button>
                      <button onClick={()=>save(true)} disabled={saving} style={{...s.btnSave,background:'#e65100'}}>بلی، ثبت شود</button>
                    </div>
                  </div>
                )}

                {lockReason && <div style={{...s.errBox,background:'#fff8e1',color:'#795548',border:'1px solid #ffe082'}}>🔒 {lockReason}</div>}
                {warn && <div style={{...s.errBox,background:'#fff3e0',color:'#bf360c'}}>⛔ {warn}</div>}

                {/* ── بخش ثابت: حساب معین + مبالغ ── */}
                <div style={s.grpTitle}>🔢 حساب معین و مبالغ</div>
                <FRow>
                  <FL label="حساب معین *" half>
                    <div style={{position:'relative'}}>
                      {/* نمایش کد انتخاب‌شده */}
                      {form.sub_coding_code ? (
                        <div style={{display:'flex',alignItems:'center',gap:'6px',
                          padding:'6px 10px',border:'1.5px solid #00695c',borderRadius:'7px',
                          background:'#e0f2f1',fontSize:'12px'}}>
                          <span style={{fontWeight:'700',color:'#00695c',fontFamily:'monospace'}}>
                            {toFa(form.sub_coding_code)}
                          </span>
                          <span style={{flex:1,color:'#333',fontSize:'11px'}}>
                            {scConfig?.name || ''}
                          </span>
                          {!subCodingLocked && <button onClick={()=>{
                            setForm(f=>({...EMPTY,...f,sub_coding_code:''}));
                            setScConfig(null);
                          }} style={{background:'none',border:'none',color:'#b71c1c',
                            cursor:'pointer',fontSize:'14px',padding:0}}>✕</button>}
                        </div>
                      ) : (
                        <input value={scSearch} ref={scInputRef} autoFocus
                          onChange={e=>handleScSearchChange(e.target.value)}
                          onClick={e=>e.stopPropagation()}
                          placeholder="کد یا نام حساب معین را تایپ کنید..."
                          style={{padding:'6px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',
                            fontSize:'12px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',
                            direction:'rtl',width:'100%',boxSizing:'border-box'}}/>
                      )}
                      {/* لیست نتایج جستجو */}
                      {scDropOpen && scResults.length > 0 && (
                        <div onClick={e=>e.stopPropagation()}
                          style={{position:'absolute',top:'100%',right:0,left:0,background:'#fff',
                          border:'1px solid #e0e0e0',borderRadius:'8px',boxShadow:'0 4px 16px rgba(0,0,0,0.15)',
                          zIndex:500,maxHeight:'200px',overflowY:'auto',marginTop:'2px'}}>
                          {scResults.map(r => (
                            <div key={r.code} onClick={()=>selectSubCoding(r)}
                              style={{padding:'7px 10px',cursor:'pointer',borderBottom:'1px solid #f5f5f5',
                                fontSize:'12px',direction:'rtl',display:'flex',alignItems:'center',gap:'8px'}}
                              onMouseEnter={e=>e.currentTarget.style.background='#e0f2f1'}
                              onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                              <span style={{fontWeight:'700',color:'#00695c',fontFamily:'monospace',
                                minWidth:'50px'}}>{toFa(r.code)}</span>
                              <span style={{flex:1,color:'#333'}}>{r.name}</span>
                              {r.entity && <span style={{fontSize:'10px',color:'#888',
                                background:'#f0f0f0',padding:'1px 6px',borderRadius:'8px'}}>{r.entity}</span>}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </FL>
                  <FL label="بدهکار" third>
                    <AmountInput name="debit" value={form.debit} onChange={hf} inputRef={debitRef} readOnly={amountsLocked}
                      onFocus={debitFocus} onBlur={amountBlur('debit')} onKeyDown={amountKeys('debit')}/>
                  </FL>
                  <FL label="بستانکار" third>
                    <AmountInput name="credit" value={form.credit} onChange={hf} inputRef={creditRef} readOnly={amountsLocked}
                      onFocus={creditFocus} onBlur={amountBlur('credit')} onKeyDown={amountKeys('credit')}/>
                  </FL>
                </FRow>
                <FRow>
                  <FL label="شرح ریز">
                    <FI name="remark" value={form.remark} onChange={hf} onKeyDown={remarkKeys}/>
                  </FL>
                </FRow>
                <FRow>
                  {recvCount > 0 && (
                    <FL label=" " third>
                      <button onClick={openInOutReceive} type="button"
                        style={{...s.btnScf,background:'linear-gradient(135deg,#37474f,#546e7a)',padding:'7px 10px'}}>
                        ⬇ دریافت از دریافت و پرداخت ({toFa(recvCount)})
                      </button>
                    </FL>
                  )}
                  <FL label="ردیف" third>
                    <FI name="paper_no" value={toFa(form.paper_no||'')} onChange={e=>setForm(f=>({...f,paper_no:toEng(e.target.value).replace(/[^0-9]/g,'')}))}/>
                  </FL>
                  <FL label="نوع سند" third>
                    <DetailLookup field="vouch_type_group_id" title="نوع سند" year={year}
                      value={si(form.vouch_type_group_id)} apiFn={API}
                      display={form.vouch_type_group_id_display ?? (selected && modal==='edit' ? selected.vouch_type_name : '')}
                      onPick={(id,label)=>setForm(f=>({...f, vouch_type_group_id:id, vouch_type_group_id_display:label}))}/>
                  </FL>
                  <FL label="شمول" third>
                    <select name="shomool" value={form.shomool||0} onChange={e=>setForm(f=>({...f,shomool:Number(e.target.value)}))}
                      style={{padding:'6px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',fontSize:'12px',
                        fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',background:'#fff',direction:'rtl'}}>
                      {SHOMOOL.map((t,i)=><option key={i} value={i}>{t}</option>)}
                    </select>
                  </FL>
                  <FL label=" " third>
                    <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px',color:'#444',
                      cursor:'pointer',paddingTop:'6px'}}>
                      <input type="checkbox" name="decrese_credit" checked={!!form.decrese_credit} onChange={hf}/>
                      کاهش اعتبار
                    </label>
                  </FL>
                </FRow>

                {/* ── لودینگ config ── */}
                {scConfigLoading && (
                  <div style={{textAlign:'center',padding:'20px',color:'#999'}}>⏳ بارگذاری تفصیلی‌ها...</div>
                )}

                {/* ── فیلدهای تفصیلی داینامیک ── */}
                {scConfig && scConfig.fields && scConfig.fields.length > 0 && (
                  <>
                    <div style={{...s.divider,margin:'12px 0'}}/>
                    <div style={s.grpTitle}>
                      📋 تفصیلی‌های حساب معین
                      <span style={{fontWeight:'400',fontSize:'11px',color:'#999',marginRight:'8px'}}>
                        ({toFa(scConfig.total)} فیلد فعال)
                      </span>
                    </div>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
                      {scConfig.fields.map(fld => (
                        <div key={fld.field} style={{
                          padding:'8px 10px',borderRadius:'8px',
                          background:'#fafafa',border:'1.5px solid #e8e8e8',
                        }}>
                          {/* مقدار ۱ ⇒ ستارهٔ قرمز + متن آبی؛ مقدار ۲ ⇒ متن مشکی */}
                          <label style={{fontSize:'10px',fontWeight:'700',
                            color:fld.required?'#0000ff':'#000',display:'flex',
                            alignItems:'center',gap:'2px',marginBottom:'4px'}}>
                            {fld.required && <span style={{color:'#ff0000'}}>*</span>}
                            {fld.label}
                          </label>
                          {fld.type === 'select' && fld.options ? (
                            <select name={fld.field}
                              value={form[fld.field]||0}
                              onChange={hf}
                              style={{padding:'5px 8px',border:'1px solid #e0e0e0',borderRadius:'6px',
                                fontSize:'11px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",
                                outline:'none',width:'100%',background:'#fff',direction:'rtl'}}>
                              <option value={0}>— انتخاب —</option>
                              {fld.options.map(o=>(
                                <option key={o.v} value={o.v}>{o.l}</option>
                              ))}
                            </select>
                          ) : fld.type === 'lookup' ? (
                            <DetailLookup
                              field={fld.field}
                              title={fld.label}
                              year={year}
                              parent={fld.field==='project_id' ? si(form.program_id)
                                : fld.field==='expense_detail_article_id' ? si(form.expense_article_id)
                                : fld.field==='expense_part_id' ? (si(form.expense_detail_article_id) || si(form.expense_article_id))
                                : fld.field==='expense_kind_id' ? (si(form.expense_part_id) || si(form.expense_detail_article_id) || si(form.expense_article_id))
                                : 0}
                              value={si(form[fld.field])}
                              display={form[fld.field+'_display'] ??
                                (selected && LOOKUP_DISPLAY_FROM_ROW[fld.field]
                                  ? selected[LOOKUP_DISPLAY_FROM_ROW[fld.field]] : '')}
                              apiFn={API}
                              readOnly={(fld.field==='nominee_id' && !!form._nominee_locked)}
                              noAuto={fld.field==='contract_id'}
                              onKeyDown={fld.field==='contract_id' ? contractKeys
                                : fld.field==='nominee_id' ? nomineeKeys : undefined}
                              onPick={(id,label,row,auto)=>{
                                if (fld.field==='contract_id' && id && row) {
                                  applyContract({ id, label, contractor_code: row.contractor_code || 0,
                                                  contractor_name: row.contractor_name || '' }, !!auto);
                                  return;
                                }
                                setForm(f=>{
                                  const nf = {...f, [fld.field]:id, [fld.field+'_display']:label};
                                  if (fld.field==='contract_id' && !id) {
                                    nf._nominee_locked = false;
                                    // قرارداد پاک شد: پیمانکاری که از همان قرارداد آمده بود هم پاک می‌شود
                                    if (f._nominee_from_contract) { nf.nominee_id = 0; nf.nominee_id_display = ''; nf._nominee_from_contract = false; }
                                  }
                                  if (fld.field==='nominee_id') nf._nominee_from_contract = false;
                                  return nf;
                                });
                              }}
                            />
                          ) : (
                            <input name={fld.field}
                              value={toFa(form[fld.field]||'')}
                              onChange={hf}
                              style={{padding:'5px 8px',border:'1px solid #e0e0e0',borderRadius:'6px',
                                fontSize:'11px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",
                                outline:'none',width:'100%',boxSizing:'border-box',direction:'rtl'}}/>
                          )}
                        </div>
                      ))}
                    </div>
                    {scConfig.fields.some(fl=>['nominee_id','people_id','amount_receiver_id'].includes(fl.field)) && (
                      <div style={{marginTop:'8px',padding:'8px 10px',borderRadius:'8px',background:'#ede7f6',
                        border:'1.5px solid #d1c4e9',fontSize:'12px',display:'flex',gap:'8px',alignItems:'center'}}>
                        <span style={{fontWeight:'700',color:'#4527a0',whiteSpace:'nowrap'}}>🏦 حساب گیرنده:</span>
                        <span style={{direction:'ltr',fontFamily:'monospace',flex:1,textAlign:'right'}}>
                          {rcvAccount.trim() ? toFa(rcvAccount)
                            : (si(form.nominee_id)||si(form.people_id)||si(form.amount_receiver_id))
                              ? <span style={{color:'#c62828',fontFamily:'inherit'}}>حسابی برای این ذینفع ثبت نشده است</span>
                              : <span style={{color:'#999',fontFamily:'inherit'}}>—</span>}
                        </span>
                        {fieldHasNominee(scConfig) && !form._nominee_locked && head.contract_id ? (
                          <button type="button" onClick={()=>applyNomineeFromContract()} style={{
                            fontSize:'11px',color:'#4527a0',whiteSpace:'nowrap',background:'rgba(69,39,160,0.08)',
                            border:'1px solid rgba(69,39,160,0.25)',borderRadius:'6px',padding:'3px 10px',
                            cursor:'pointer',fontFamily:'inherit',fontWeight:'600',transition:'all .2s'
                          }} onMouseEnter={e=>{e.currentTarget.style.background='rgba(69,39,160,0.18)';}}
                             onMouseLeave={e=>{e.currentTarget.style.background='rgba(69,39,160,0.08)';}}>
                            نشاندن حساب پیمانکار</button>) : null}
                      </div>)}
                  </>
                )}

                {/* ── پیام: حساب معین انتخاب نشده ── */}
                {!form.sub_coding_code && !scConfigLoading && (
                  <div style={{textAlign:'center',padding:'30px',color:'#bbb',fontSize:'13px',
                    border:'2px dashed #e0e0e0',borderRadius:'10px',margin:'16px 0'}}>
                    ابتدا حساب معین را انتخاب کنید تا فیلدهای تفصیلی نمایش داده شوند
                  </div>
                )}

                {/* ── حساب معین بدون تفصیلی ── */}
                {scConfig && scConfig.fields && scConfig.fields.length === 0 && (
                  <div style={{textAlign:'center',padding:'20px',color:'#999',fontSize:'12px',
                    margin:'10px 0'}}>
                    این حساب معین تفصیلی ندارد
                  </div>
                )}
              </div>
              <div style={s.iFooter}>
                <button onClick={()=>setModal(null)} style={s.btnCancel}>انصراف</button>
{perms.can_ok &&                 <button onClick={()=>save()} disabled={saving||!form.sub_coding_code} style={{...s.btnSave,
                  opacity:(!form.sub_coding_code||saving)?0.5:1}}>
                  {saving?'⏳ ذخیره...':'💾 ذخیره'}
                </button>}
              </div>
            </div>
          </div>
        )}

        {/* پاپ‌آپ تفصیلی‌های حساب معین */}
        {scfOpen && (
          <div style={s.innerOverlay} onClick={()=>setScfOpen(false)}>
            <div style={{...s.innerModal,maxWidth:'680px'}} onClick={e=>e.stopPropagation()}>
              <div style={{...s.iHeader,background:'linear-gradient(135deg,#00695c,#00897b)'}}>
                <span style={{fontSize:'14px',fontWeight:'700',color:'#fff'}}>
                  📋 تفصیلی‌های این قلم
                  <span style={{fontWeight:'400',fontSize:'11px',
                    background:'rgba(255,255,255,0.18)',border:'1px solid rgba(255,255,255,0.3)',
                    borderRadius:'10px',padding:'2px 9px',marginRight:'10px'}}>
                    فقط نمایش — چیزی تغییر نمی‌کند
                  </span>
                </span>
                <button onClick={()=>setScfOpen(false)} style={s.closeBtn}>✕</button>
              </div>
              <div style={s.iBody}>
                {scfLoading ? (
                  <div style={{textAlign:'center',padding:'40px',color:'#999'}}>⏳ بارگذاری تفصیلی‌ها...</div>
                ) : scfData ? (
                  <>
                    {/* هدر اطلاعات حساب */}
                    <div style={{background:'#e0f2f1',borderRadius:'8px',padding:'12px 14px',
                      marginBottom:'14px',display:'flex',gap:'20px',flexWrap:'wrap',
                      alignItems:'center',borderRight:'4px solid #00695c'}}>
                      <div style={{fontSize:'13px'}}>
                        <span style={{color:'#666',fontSize:'11px'}}>کد: </span>
                        <span style={{fontWeight:'700',color:'#00695c',fontFamily:'monospace',fontSize:'15px'}}>
                          {toFa(scfData.code)}
                        </span>
                      </div>
                      <div style={{fontSize:'13px'}}>
                        <span style={{color:'#666',fontSize:'11px'}}>عنوان: </span>
                        <span style={{fontWeight:'700',color:'#1a2f50'}}>{scfData.name}</span>
                      </div>
                      {scfData.entity && (
                        <span style={{fontSize:'11px',
                          background:scfData.entity==='بدهکار'?'#ffebee':'#e8f5e9',
                          color:scfData.entity==='بدهکار'?'#b71c1c':'#1b5e20',
                          padding:'3px 10px',borderRadius:'12px',fontWeight:'700'}}>
                          {scfData.entity}
                        </span>
                      )}
                      {scfData._row && scfData._row.debit > 0 && (
                        <span style={{fontSize:'12px',fontWeight:'700',color:'#b71c1c'}}>
                          بدهکار: {numFmt(scfData._row.debit)}
                        </span>
                      )}
                      {scfData._row && scfData._row.credit > 0 && (
                        <span style={{fontSize:'12px',fontWeight:'700',color:'#1b5e20'}}>
                          بستانکار: {numFmt(scfData._row.credit)}
                        </span>
                      )}
                    </div>

                    {/* لیست فیلدهای فعال */}
                    {(!scfData.attributes || scfData.attributes.length === 0) ? (
                      <div style={{textAlign:'center',padding:'30px',color:'#999',fontSize:'13px'}}>
                        این حساب معین تفصیلی ندارد
                      </div>
                    ) : (
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
                        {scfData.attributes.map((attr, i) => {
                          const rowKey = FIELD_TO_ROW[attr.field];
                          const row = scfData._row || {};
                          const rawVal = rowKey ? row[rowKey] : '';
                          const displayVal = (rawVal && rawVal !== 0 && rawVal !== '0')
                            ? String(rawVal) : '';
                          const hasVal = !!displayVal;
                          return (
                            <div key={attr.field} style={{
                              padding:'9px 12px',borderRadius:'8px',
                              background:hasVal?'#e8f5e9':'#fafafa',
                              border:`1.5px solid ${hasVal?'#81c784':'#e0e0e0'}`,
                              borderRight:`4px solid ${hasVal?'#43a047':'transparent'}`,
                            }}>
                              <div style={{display:'flex',alignItems:'center',gap:'6px',marginBottom:hasVal?'4px':'0'}}>
                                <span style={{fontSize:'10px',color:'#999',fontFamily:'monospace',
                                  minWidth:'18px',textAlign:'center'}}>
                                  {toFa(i+1)}
                                </span>
                                {/* ۱ ⇒ ستارهٔ قرمز + متن آبی؛ ۲ ⇒ متن مشکی */}
                                <span style={{fontSize:'11px',fontWeight:'600',flex:1,
                                  color:attr.required?'#0000ff':'#000'}}>
                                  {attr.required && <span style={{color:'#ff0000'}}>*</span>}
                                  {attr.label}
                                </span>
                              </div>
                              {hasVal && (
                                <div style={{fontSize:'12px',fontWeight:'700',color:'#1b5e20',
                                  paddingRight:'24px',wordBreak:'break-word',direction:'rtl'}}>
                                  {toFa(displayVal)}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </>
                ) : (
                  <div style={{textAlign:'center',padding:'30px',color:'#c62828'}}>خطا در بارگذاری</div>
                )}
              </div>
              <div style={{...s.iFooter,justifyContent:'space-between'}}>
                <span style={{fontSize:'11px',color:'#999'}}>
                  {scfData ? `${toFa(scfData.total)} فیلد فعال` : ''}
                </span>
                <div style={{display:'flex',gap:'8px'}}>
                  {perms.can_edit && scfData && (
                    <button
                      onClick={()=>{
                        if (isLocked) return;
                        const row = scfData._row;
                        if (!row) return;
                        setScfOpen(false);
                        setSelected(row);
                        openEdit(row);
                      }}
                      disabled={isLocked}
                      title={isLocked?locked_tip:'ویرایش تفصیلی‌های این قلم'}
                      style={{...s.btnSave,background:isLocked?'#bbb':'#00695c',
                        cursor:isLocked?'not-allowed':'pointer',opacity:isLocked?.6:1}}>
                      ✎ ویرایش تفصیلی‌ها
                    </button>
                  )}
                  <button onClick={()=>setScfOpen(false)} style={s.btnClose}>بستن</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* پاپ‌آپ حذف */}
        {modal==='delete' && (
          <div style={s.innerOverlay} onClick={()=>setModal(null)}>
            <div style={{...s.innerModal,maxWidth:'420px'}} onClick={e=>e.stopPropagation()}>
              <div style={{...s.iHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
                <span style={{fontSize:'14px',fontWeight:'700',color:'#fff'}}>⚠️ حذف قلم</span>
                <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
              </div>
              <div style={{padding:'24px',textAlign:'center'}}>
                <div style={{fontSize:'32px',marginBottom:'10px'}}>🗑️</div>
                <div style={{background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'8px',
                  padding:'10px',fontWeight:'700',color:'#b71c1c'}}>
                  ردیف {toFa(selected?.paper_no)} — {selected?.sub_coding_name||'—'}
                  <br/><span style={{fontWeight:'400',fontSize:'12px'}}>{selected?.remark||''}</span>
                </div>
              </div>
              <div style={s.iFooter}>
                <button onClick={()=>setModal(null)} style={s.btnCancel}>خیر</button>
                <button onClick={doDelete} disabled={saving}
                  style={{...s.btnSave,background:'#b71c1c'}}>
                  {saving?'⏳...':'بله، حذف'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* پاپ‌آپ حذف گروهی اقلام — تأیید ساده */}
        {modal==='group-delete' && (
          <div style={s.innerOverlay} onClick={()=>setModal(null)}>
            <div style={{...s.innerModal,maxWidth:'460px'}} onClick={e=>e.stopPropagation()}>
              <div style={{...s.iHeader,background:'linear-gradient(135deg,#e65100,#ef6c00)'}}>
                <span style={{fontSize:'14px',fontWeight:'700',color:'#fff'}}>⚠️ حذف اقلام انتخابی</span>
                <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
              </div>
              <div style={{padding:'24px',textAlign:'center'}}>
                <div style={{fontSize:'32px',marginBottom:'10px'}}>🗑️</div>
                <div style={{background:'#fff8e1',border:'1px solid #ffe0b2',borderRadius:'8px',
                  padding:'12px',fontWeight:'700',color:'#e65100',fontSize:'13px'}}>
                  آيا از حذف اقلام انتخابی مطمئن هستيد؟
                  <div style={{fontWeight:'400',fontSize:'12px',marginTop:'6px',color:'#666'}}>
                    {toFa(picked.length)} قلم انتخاب شده است
                  </div>
                </div>
              </div>
              <div style={s.iFooter}>
                <button onClick={()=>setModal(null)} style={s.btnCancel}>خیر</button>
                <button onClick={()=>doGroupDelete('picked')} disabled={saving}
                  style={{...s.btnSave,background:'#e65100'}}>
                  {saving?'⏳...':'بله، حذف'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* پرسش سه‌گزینه‌ای (سند حواله‌ای یا بیش از ۵۰ قلم) */}
        {groupAsk && (
          <div style={s.innerOverlay} onClick={()=>setGroupAsk(null)}>
            <div style={{...s.innerModal,maxWidth:'560px'}} onClick={e=>e.stopPropagation()}>
              <div style={{...s.iHeader,background:'linear-gradient(135deg,#0a1628,#1a2f50)'}}>
                <span style={{fontSize:'14px',fontWeight:'700',color:'#fff'}}>هشدار</span>
                <button onClick={()=>setGroupAsk(null)} style={s.closeBtn}>✕</button>
              </div>
              <div style={{padding:'20px'}}>
                <div style={{background:'#fbf7ea',border:'1px solid #ece0c0',
                  borderRight:'4px solid #C8A84B',borderRadius:'10px',padding:'14px 16px',
                  fontSize:'13px',lineHeight:2,color:'#2b2b2b',whiteSpace:'pre-line'}}>
                  {groupAsk.msg}
                </div>
              </div>
              <div style={{...s.iFooter,gap:'8px'}}>
                <button onClick={()=>{setGroupAsk(null);cancelMulti();}} style={s.btnCancel}>لغو</button>
                <button onClick={()=>doGroupDelete('picked')} disabled={saving}
                  style={{...s.btnSave,background:'#e65100'}}>فقط اقلام انتخاب شده</button>
                <button onClick={()=>doGroupDelete('all')} disabled={saving}
                  style={{...s.btnSave,background:'#b71c1c'}}>همه اقلام</button>
              </div>
            </div>
          </div>
        )}

        {/* پاپ‌آپ حساب ذینفع */}
        {raOpen && (
          <div style={s.innerOverlay} onClick={()=>{setRaOpen(false);setRaForm(null);}}>
            <div style={{...s.innerModal,maxWidth:'860px'}} onClick={e=>e.stopPropagation()}>
              <div style={{...s.iHeader,background:'linear-gradient(135deg,#4527a0,#5e35b1)'}}>
                <span style={{fontSize:'14px',fontWeight:'700',color:'#fff'}}>
                  🏦 حساب ذینفع
                  {raData && raData.owner && (
                    <span style={{fontWeight:'400',marginRight:'10px'}}>— {raData.owner}</span>
                  )}
                </span>
                <button onClick={()=>{setRaOpen(false);setRaForm(null);}} style={s.closeBtn}>✕</button>
              </div>
              <div style={s.iBody}>
                {raErr && <div style={s.errBox}>⚠️ {raErr}</div>}
                {raLoading ? (
                  <div style={{textAlign:'center',padding:'40px',color:'#999'}}>⏳ بارگذاری...</div>
                ) : !raData ? (
                  <div style={{textAlign:'center',padding:'30px',color:'#c62828'}}>خطا در بارگذاری</div>
                ) : !raData.kind ? (
                  <div style={{textAlign:'center',padding:'30px',color:'#999',fontSize:'13px'}}>
                    برای این قلم، ذینفعی (پیمانکار / گیرندهٔ وجه / شخص) ثبت نشده است
                  </div>
                ) : (
                  <>
                    <table style={{...s.table,fontSize:'12px'}}>
                      <thead><tr>
                        <th style={s.th}>اثرگذار</th>
                        <th style={s.th}>شماره</th>
                        <th style={s.th}>تاریخ</th>
                        <th style={s.th}>حساب</th>
                        <th style={s.th}>بانک</th>
                        <th style={s.th}>قرارداد</th>
                        <th style={s.th}>خطای شبا</th>
                        <th style={s.th}></th>
                      </tr></thead>
                      <tbody>
                        {raData.data.length===0 && (
                          <tr><td colSpan={8} style={{textAlign:'center',padding:'26px',color:'#999'}}>
                            حسابی ثبت نشده است
                          </td></tr>
                        )}
                        {raData.data.map((a,i)=>(
                          <tr key={a.id||i} style={{background:a.active?'#e8f5e9':i%2?'#fff':'#fafafa'}}>
                            <td style={{...s.td,textAlign:'center'}}>{a.active?'✅':a.eligible?'○':'—'}</td>
                            <td style={{...s.td,textAlign:'center'}}>{toFa(a.letter_no)}</td>
                            <td style={{...s.td,textAlign:'center'}}>{toFa(a.letter_date)}</td>
                            <td style={{...s.td,textAlign:'center',fontFamily:'monospace'}}>{toFa(a.account_no)}</td>
                            <td style={{...s.td,textAlign:'right'}}>{a.bank}</td>
                            <td style={{...s.td,textAlign:'right'}}>{toFa(a.contract)}</td>
                            <td style={{...s.td,textAlign:'center',color:'#c62828'}}>{a.sheba_error}</td>
                            <td style={{...s.td,textAlign:'center',whiteSpace:'nowrap'}}>
                              {raData.kind==='contractor' && !raForm && (<>
                                {a.can_edit && a.sheba_calc && (
                                  <button onClick={()=>shebaReceiverAccount(a)} title="محاسبهٔ شماره شبا"
                                    style={{...s.btnEdit,padding:'3px 8px',fontSize:'11px',marginLeft:'4px',
                                      background:'#00695c'}}>شبا</button>)}
                                {a.can_edit && (
                                  <button onClick={()=>editReceiverAccount(a)} title="ویرایش"
                                    style={{...s.btnEdit,padding:'3px 10px',fontSize:'11px',marginLeft:'4px'}}>✎</button>)}
                                {a.can_delete && (
                                  <button onClick={()=>deleteReceiverAccount(a)} title="حذف"
                                    style={{...s.btnEdit,padding:'3px 10px',fontSize:'11px',background:'#c62828'}}>✕</button>)}
                                {!a.can_edit && !a.can_delete && (
                                  <span title={a.scope_note || 'دسترسی ویرایش این حساب را ندارید'}
                                    style={{color:'#bbb'}}>🔒</span>)}
                              </>)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* فرم ثبت/ویرایش حساب */}
                    {raForm && (
                      <div style={{marginTop:'14px',border:'1.5px solid #d1c4e9',borderRadius:'10px',
                        padding:'12px 14px',background:'#faf8ff'}}>
                        <div style={{fontSize:'12px',fontWeight:'700',color:'#4527a0',marginBottom:'10px'}}>
                          {raForm.id?'ویرایش حساب':'حساب جدید'}
                          {' — '}{raForm.scope==='contract'?'برای قرارداد این قلم':'حساب عمومی پیمانکار'}
                        </div>
                        <FRow>
                          <FL label="شماره نامه" third>
                            <FI name="letter_no" value={raForm.letter_no}
                              onChange={e=>setRaForm(f=>({...f,letter_no:e.target.value}))}/>
                          </FL>
                          <FL label="تاریخ نامه" third>
                            <FI name="letter_date" value={raForm.letter_date}
                              placeholder="۱۴۰۵/۰۱/۰۱"
                              onChange={e=>setRaForm(f=>({...f,letter_date:e.target.value}))}/>
                          </FL>
                          <FL label="شماره حساب / شبا" third>
                            <FI name="account_no" value={raForm.account_no}
                              onChange={e=>setRaForm(f=>({...f,account_no:e.target.value}))}/>
                          </FL>
                        </FRow>
                        <FRow>
                          <FL label="شعبهٔ بانک">
                            <DetailLookup field="bank_branch" title="شعبهٔ بانک" year={year}
                              value={raForm.branch_code} display={raForm.branch_display}
                              apiFn={(path)=>API(path.replace('/detail-lookup/','/lookup/bank-branch/'))}
                              onPick={(id,label)=>setRaForm(f=>({...f,branch_code:id,branch_display:label}))}/>
                          </FL>
                        </FRow>
                        <div style={{display:'flex',justifyContent:'flex-end',gap:'8px',marginTop:'6px'}}>
                          <button onClick={()=>setRaForm(null)} style={s.btnCancel}>انصراف</button>
                          <button onClick={()=>saveReceiverAccount(false)} disabled={raSaving}
                            style={{...s.btnSave,background:'#4527a0'}}>
                            {raSaving?'⏳ ذخیره...':'💾 ذخیره'}
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              <div style={{...s.iFooter,justifyContent:'space-between'}}>
                <span style={{fontSize:'11px',color:'#999'}}>
                  {raData && raData.kind==='people' && 'حساب‌های پرسنلی از سامانهٔ حقوق و دستمزد خوانده می‌شوند و اینجا قابل ویرایش نیستند'}
                  {raData && raData.kind==='amount_receiver' && 'حساب گیرندهٔ وجه از فرم «گیرندگان وجه» اصلاح می‌شود'}
                </span>
                <div style={{display:'flex',gap:'8px'}}>
                  {raData && raData.kind==='contractor' && !raForm && raData.can_new_contract && (
                    <button onClick={()=>newReceiverAccount('contract')}
                      style={{...s.btnSave,background:'#4527a0'}}>＋ حساب جدید برای این قرارداد</button>
                  )}
                  {raData && raData.kind==='contractor' && !raForm && raData.can_new_general && (
                    <button onClick={()=>newReceiverAccount('general')}
                      style={{...s.btnSave,background:'#5e35b1'}}>＋ حساب عمومی پیمانکار</button>
                  )}
                  <button onClick={()=>{setRaOpen(false);setRaForm(null);}} style={s.btnClose}>بستن</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {(stmt || summary) && (
          <div style={{position:'fixed',inset:0,background:'rgba(10,22,40,.5)',zIndex:100400,display:'flex',
            alignItems:'center',justifyContent:'center',padding:'16px'}} onClick={()=>{setStmt(null);setSummary(null);}}>
            <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:'10px',width:'100%',maxWidth:'980px',
              maxHeight:'75vh',display:'flex',flexDirection:'column',direction:'rtl',overflow:'hidden'}}>
              <div style={{padding:'10px 14px',background:'#1a2f50',color:'#fff',fontWeight:700,fontSize:'13px',
                display:'flex',justifyContent:'space-between'}}>
                <span>{stmt ? 'صورت وضعیت‌های قرارداد — برای وصل کردن به قلم روی ردیف دابل‌کلیک کنید' : 'خلاصهٔ اقلام به تفکیک حساب معین'}</span>
                <button onClick={()=>{setStmt(null);setSummary(null);}} style={{background:'none',border:'none',color:'#fff',cursor:'pointer'}}>✕</button>
              </div>
              <div style={{overflow:'auto'}}>
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:'11px'}}>
                  <thead><tr style={{background:'#eceff1'}}>
                    {(stmt ? ['سریال','نوع','شماره','مبلغ کارکرد','بیمه سهم دولت','مالیات بر ارزش افزوده','از تاریخ','تا تاریخ','توضیحات','شماره نامه','تاریخ نامه']
                           : ['حساب معین','تعداد','بدهکار','بستانکار']).map(h=><th key={h} style={{padding:'6px',textAlign:'right',background:'#eceff1',position:'sticky',top:0,zIndex:2}}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {stmt && stmt.map(r=>(
                      <tr key={r.id} onDoubleClick={()=>pickStatement(r.id)} style={{cursor:'pointer',borderBottom:'1px solid #f0f0f0'}}
                        onMouseEnter={e=>e.currentTarget.style.background='#eef5ff'} onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                        <td style={{padding:'6px'}}>{toFa(r.serial)}</td><td>{r.type}</td><td>{toFa(r.request_no)}</td>
                        <td>{numFmt(r.amount)}</td><td>{numFmt(r.insure)}</td><td>{numFmt(r.tax)}</td>
                        <td>{toFa(r.from_date)}</td><td>{toFa(r.to_date)}</td><td>{r.remark}</td>
                        <td>{toFa(r.letter_no)}</td><td>{toFa(r.letter_date)}</td>
                      </tr>
                    ))}
                    {summary && summary.rows.map((r,i)=>(
                      <tr key={i} style={{borderBottom:'1px solid #f0f0f0'}}>
                        <td style={{padding:'6px'}}>{toFa(r.sub_coding)}</td><td>{toFa(r.count)}</td>
                        <td>{numFmt(r.debit)}</td><td>{numFmt(r.credit)}</td>
                      </tr>
                    ))}
                    {((stmt && stmt.length===0) || (summary && summary.rows.length===0)) && (
                      <tr><td colSpan={11} style={{padding:'20px',textAlign:'center',color:'#999'}}>موردی یافت نشد</td></tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {io && (
          <div style={{position:'fixed',inset:0,background:'rgba(10,22,40,.5)',zIndex:100450,display:'flex',
            alignItems:'center',justifyContent:'center',padding:'16px'}} onClick={()=>setIo(null)}>
            <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:'10px',width:'100%',maxWidth:'1000px',
              maxHeight:'70vh',display:'flex',flexDirection:'column',direction:'rtl',overflow:'hidden'}}>
              <div style={{padding:'10px 14px',background:'#37474f',color:'#fff',fontWeight:700,fontSize:'13px',
                display:'flex',justifyContent:'space-between'}}>
                <span>{io.mode==='match' ? 'دریافت و پرداخت‌های هم‌مبلغ — برای وصل کردن دابل‌کلیک کنید'
                                          : 'دریافت از دریافت و پرداخت — برای انتخاب دابل‌کلیک کنید'}</span>
                <button onClick={()=>setIo(null)} style={{background:'none',border:'none',color:'#fff',cursor:'pointer'}}>✕</button>
              </div>
              <div style={{overflow:'auto'}}>
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:'11px'}}>
                  <thead><tr style={{background:'#eceff1'}}>
                    {(io.mode==='match'
                      ? ['شماره','تاریخ دفتر','تاریخ بانک','حساب','شرح','مبلغ','شرح ریز','مبلغ ریز']
                      : ['سیستم','شماره','بدهکار','بستانکار','شرح','گیرنده/واریزکننده','قرارداد']).map(h=>(
                      <th key={h} style={{padding:'6px',textAlign:'right',background:'#eceff1',position:'sticky',top:0,zIndex:2}}>{h}</th>))}
                  </tr></thead>
                  <tbody>
                    {io.rows.map((r,i)=>(
                      <tr key={i} style={{cursor:'pointer',borderBottom:'1px solid #f0f0f0'}}
                        onDoubleClick={()=> io.mode==='match' ? pickInOutMatch(r) : pickInOutReceive(r)}
                        onMouseEnter={e=>e.currentTarget.style.background='#eef5ff'}
                        onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                        {io.mode==='match' ? (<>
                          <td style={{padding:'6px'}}>{toFa(r.number)}</td><td>{toFa(r.daftar_date)}</td>
                          <td>{toFa(r.bank_date)}</td><td>{toFa(r.account)}</td><td>{r.remark}</td>
                          <td>{numFmt(r.amount)}</td><td>{r.detail_remark}</td><td>{numFmt(r.detail_amount)}</td>
                        </>) : (<>
                          <td style={{padding:'6px'}}>دریافت و پرداخت</td><td>{toFa(r.number)}</td>
                          <td>{numFmt(r.debit)}</td><td>{numFmt(r.credit)}</td><td>{r.remark}</td>
                          <td>{r.contractor}</td><td>{toFa(r.contract)}</td>
                        </>)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {blOpen && (
          <ContractorBlackList contractorCode={blOpen.code} contractorName={blOpen.name}
            onClose={()=>{ setBlOpen(null); load(); }}/>
        )}

        {/* انتخاب شرح آماده (F1) */}
        {rmOpen && (
          <div style={{position:'fixed',inset:0,background:'rgba(10,22,40,.5)',zIndex:100400,display:'flex',
            alignItems:'center',justifyContent:'center'}} onClick={()=>setRmOpen(false)}>
            <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:'10px',width:'520px',
              maxHeight:'70vh',display:'flex',flexDirection:'column',direction:'rtl',overflow:'hidden'}}>
              <div style={{padding:'10px 14px',background:'#1565c0',color:'#fff',fontWeight:700,fontSize:'13px'}}>
                انتخاب شرح آماده — کد را بنویسید و Enter بزنید
              </div>
              <input autoFocus value={toFa(rmQ)} onChange={e=>loadRemarks(e.target.value)}
                onKeyDown={e=>{
                  if (e.key==='Escape') setRmOpen(false);
                  if (e.key==='Enter') { const c = si(rmQ); if (c) pickRemark(c); else if (rmRows[0]) pickRemark(rmRows[0].code); }
                }}
                placeholder="کد یا بخشی از متن"
                style={{margin:'10px 14px',padding:'7px 10px',border:'1px solid #ddd',borderRadius:'7px',
                  fontFamily:'inherit',fontSize:'12px'}}/>
              <div style={{flex:1,overflowY:'auto'}}>
                {rmRows.map(r=>(
                  <div key={r.code} onClick={()=>pickRemark(r.code)}
                    style={{padding:'7px 14px',fontSize:'12px',cursor:'pointer',borderBottom:'1px solid #f2f2f2'}}
                    onMouseEnter={e=>e.currentTarget.style.background='#eef5ff'}
                    onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                    <b style={{color:'#1565c0',marginLeft:'8px'}}>{toFa(r.code)}</b>{r.remark}
                  </div>
                ))}
                {rmRows.length===0 && <div style={{padding:'20px',textAlign:'center',color:'#aaa',fontSize:'12px'}}>موردی یافت نشد</div>}
              </div>
            </div>
          </div>
        )}

        {toast && <div style={s.toast}>{toast}</div>}
      </div>
    </div>
  );
}

const s = {
  overlay:     {position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:2000,
                display:'flex',alignItems:'center',justifyContent:'center',padding:'8px'},
  modal:       {background:'#f0f2f7',borderRadius:'14px',width:'100%',maxWidth:'1500px',
                height:'90vh',display:'flex',flexDirection:'column',
                boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden'},
  mHeader:     {display:'flex',justifyContent:'space-between',alignItems:'center',
                padding:'12px 18px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',flexShrink:0},
  toolbar:     {display:'flex',alignItems:'center',gap:'10px',padding:'9px 14px',
                background:'#fff',borderBottom:'1px solid #e0e0e0',flexShrink:0,flexWrap:'wrap'},
  tableWrap:   {flex:1,overflowX:'auto',overflowY:'auto',background:'#fff'},
  table:       {borderCollapse:'collapse',direction:'rtl',tableLayout:'fixed'},
  th:          {padding:'7px 8px',fontWeight:'700',textAlign:'center',whiteSpace:'nowrap',
                borderLeft:'1px solid rgba(255,255,255,0.1)',fontSize:'11px',
                position:'sticky',top:0,zIndex:3},
  td:          {padding:'5px 7px',borderBottom:'1px solid #f0f0f0',fontSize:'11px',whiteSpace:'nowrap'},
  footer:      {display:'flex',justifyContent:'space-between',alignItems:'center',
                padding:'8px 14px',borderTop:'1px solid #e0e0e0',background:'#fff',flexShrink:0},
  errBox:      {background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'7px',
                padding:'7px 12px',color:'#c62828',margin:'6px 12px',fontSize:'12px'},
  closeBtn:    {background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',
                color:'#fff',width:'27px',height:'27px',borderRadius:'50%',cursor:'pointer',
                fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center'},
  btnNew:      {padding:'6px 14px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',
                color:'#fff',border:'none',borderRadius:'7px',fontFamily:'inherit',fontSize:'12px',fontWeight:'700'},
  btnEdit:     {padding:'6px 14px',background:'linear-gradient(135deg,#1a237e,#283593)',
                color:'#fff',border:'none',borderRadius:'7px',fontFamily:'inherit',fontSize:'12px',fontWeight:'700'},
  btnDel:      {padding:'6px 14px',background:'linear-gradient(135deg,#b71c1c,#c62828)',
                color:'#fff',border:'none',borderRadius:'7px',fontFamily:'inherit',fontSize:'12px',fontWeight:'700'},
  btnScf:      {padding:'6px 14px',background:'linear-gradient(135deg,#00695c,#00897b)',
                color:'#fff',border:'none',borderRadius:'7px',fontFamily:'inherit',fontSize:'12px',fontWeight:'700',
                transition:'all .2s'},
  btnClose:    {padding:'6px 16px',background:'linear-gradient(135deg,#37474f,#455a64)',
                color:'#fff',border:'none',borderRadius:'7px',cursor:'pointer',
                fontFamily:'inherit',fontSize:'12px'},
  innerOverlay:{position:'absolute',inset:0,background:'rgba(0,0,0,0.55)',zIndex:10,
                display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'},
  innerModal:  {background:'#fff',borderRadius:'14px',width:'100%',maxWidth:'760px',
                maxHeight:'88vh',display:'flex',flexDirection:'column',
                boxShadow:'0 16px 48px rgba(0,0,0,0.4)'},
  iHeader:     {display:'flex',justifyContent:'space-between',alignItems:'center',
                padding:'13px 16px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',
                borderRadius:'14px 14px 0 0',flexShrink:0},
  iBody:       {overflowY:'auto',flex:1,padding:'14px'},
  iFooter:     {display:'flex',justifyContent:'flex-end',gap:'8px',padding:'10px 14px',
                borderTop:'1px solid #f0f2f7',background:'#f8f9fa',
                borderRadius:'0 0 14px 14px',flexShrink:0},
  grpTitle:    {fontSize:'12px',fontWeight:'700',color:'#1a2f50',marginBottom:'7px',
                paddingBottom:'4px',borderBottom:'1.5px solid #e8eaf6'},
  divider:     {height:'1px',background:'#f0f2f7',margin:'10px 0'},
  btnCancel:   {padding:'7px 16px',background:'#e0e0e0',color:'#333',border:'none',
                borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'12px'},
  btnSave:     {padding:'7px 20px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',
                color:'#fff',border:'none',borderRadius:'7px',cursor:'pointer',
                fontFamily:'inherit',fontSize:'12px',fontWeight:'700'},
  toast:       {position:'absolute',bottom:'14px',right:'14px',background:'#1b5e20',
                color:'#fff',padding:'9px 18px',borderRadius:'8px',fontSize:'12px',
                fontWeight:'600',zIndex:20},
};